/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Invisible Themes.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */
!(function (t, e, s, i, o) {
  "use strict";
  function n(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let r = d();
  function a() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = u('[data-section-type*="footer"]')),
      (t.headerHeight = u("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = u("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = u("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function l() {
    document.addEventListener("theme:resize", h), c();
  }
  function c() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = a();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function h() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = a(),
      n = d();
    (n !== r || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (r = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function d() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function u(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  function p(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }
  function m() {
    return (
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      window.innerWidth
    );
  }
  function g() {
    return (
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      window.innerHeight
    );
  }
  function v() {
    return m() >= window.theme.sizes.small;
  }
  function y() {
    return m() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let f = m(),
    b = g();
  let w = window.scrollY,
    S = null,
    E = null,
    L = null,
    k = null,
    A = 0;
  function C(e) {
    setTimeout(() => {
      A && clearTimeout(A),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function T(t) {
    const e = t.detail;
    e ? (A = setTimeout(q, e)) : q();
  }
  function q() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const x = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };
  function P(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      x(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      x(t, "rte__video-wrapper");
    });
  }
  function M(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const I = "is-loading",
    H = "img.is-loading";
  function O(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function D(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var B = {};
  function _(t, e) {
    e = e || {};
    var s = D(t),
      i = e.elementToFocus || t,
      o = s[0],
      n = s[s.length - 1];
    F(),
      (B.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          o &&
          o === e.target &&
          o.focus(),
          (e.target !== t && e.target !== n && e.target !== o) ||
            document.addEventListener("keydown", B.keydown);
      }),
      (B.focusout = function () {
        document.removeEventListener("keydown", B.keydown);
      }),
      (B.keydown = function (e) {
        "Tab" === e.code &&
          (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
          (e.target !== t && e.target !== o) ||
            !e.shiftKey ||
            (e.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", B.focusout),
      document.addEventListener("focusin", B.focusin),
      O(i, e);
  }
  function F() {
    document.removeEventListener("focusin", B.focusin),
      document.removeEventListener("focusout", B.focusout),
      document.removeEventListener("keydown", B.keydown);
  }
  function $() {
    window.accessibility.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        window.accessibility.lastElement?.focus();
      });
  }
  var N = Object.freeze({
    __proto__: null,
    forceFocus: O,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && O(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                O(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: D,
    trapFocus: _,
    removeTrapFocus: F,
    autoFocusLastElement: $,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          i = e.prefix || "a11y",
          o = {
            newWindow: i + "-new-window-message",
            external: i + "-external-message",
            newWindowExternal: i + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            n = "_blank" === e,
            r = null === s || -1 === s.indexOf("noopener");
          if (n && r) {
            var a = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", a);
          }
          i && n
            ? t.setAttribute("aria-describedby", o.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", o.external)
            : n && t.setAttribute("aria-describedby", o.newWindow);
        }),
          (function (t) {
            var e = document.createElement("ul"),
              s = Object.keys(t).reduce(function (e, s) {
                return e + "<li id=" + o[s] + ">" + t[s] + "</li>";
              }, "");
            e.setAttribute("hidden", !0),
              (e.innerHTML = s),
              document.body.appendChild(e);
          })(s);
      }
    },
  });
  const W = 'input[type="search"]',
    R = '[aria-selected="true"] a',
    z = 'button[type="reset"]',
    U = "hidden";
  class V extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(W)),
        (this.resetButton = this.querySelector(z)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            p((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
    toggleResetButton() {
      const t = this.resetButton.classList.contains(U);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(U)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(U);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(R);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(W).focus());
    }
  }
  customElements.define("header-search-form", V);
  const j = '[role="option"]',
    X = '[aria-selected="true"]',
    J = "[data-popular-searches]",
    Y = "predictive-search",
    Q = "[data-predictive-search-results]",
    G = "[data-predictive-search-status]",
    K = 'input[type="search"]',
    Z = "[data-popdown]",
    tt = "[data-predictive-search-live-region-count-value]",
    et = "[data-search-results-groups-wrapper]",
    st = "[data-predictive-search-search-for-text]",
    it = "#shopify-section-predictive-search",
    ot = '[aria-selected="true"] a',
    nt = '[aria-selected="true"] a, button[aria-selected="true"]';
  class rt extends V {
    constructor() {
      super(),
        (this.a11y = N),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(Y)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(K)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(Q)),
        (this.searchPopdown = this.closest(Z)),
        (this.popularSearches = this.searchPopdown?.querySelector(J)),
        (this.searchTerm = "");
    }
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        this.querySelector(et)?.remove(),
        this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(ot)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(ot);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(st),
        i = s?.innerText;
      if (i) {
        if (i.match(new RegExp(t, "g"))?.length > 1) return;
        const o = i.replace(t, e);
        s.innerText = o;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(X),
        i = Array.from(this.querySelectorAll(j)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(nt);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(it).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== t?.code) throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(G)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(tt).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0),
        this.predictiveSearchResults.style.setProperty(
          "--full-screen",
          `${window.visualViewport.height}px`
        );
    }
    close(t = !1) {
      this.closeResults(t),
        (this.isOpen = !1),
        this.predictiveSearchResults.style.removeProperty("--full-screen");
    }
    closeResults(t = !1) {
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const e = this.querySelector(X);
      e && e.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        this.predictiveSearchResults?.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
  }
  const at = "[data-popout-list]",
    lt = "[data-popout-toggle]",
    ct = "[data-popout-toggle-text]",
    ht = "[data-popout-input]",
    dt = "[data-popout-option]",
    ut = "[data-product-image]",
    pt = "[data-grid-item]",
    mt = "popout-list--visible",
    gt = "is-visible",
    vt = "is-active",
    yt = "select-popout--top",
    ft = "aria-expanded",
    bt = "aria-current",
    wt = "data-value",
    St = "data-popout-toggle-text",
    Et = "submit";
  class Lt extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.popoutList = this.querySelector(at)),
        (this.popoutToggle = this.querySelector(lt)),
        (this.popoutToggleText = this.querySelector(ct)),
        (this.popoutInput = this.querySelector(ht)),
        (this.popoutOptions = this.querySelectorAll(dt)),
        (this.productGridItem = this.popoutList.closest(pt)),
        (this.fireSubmitEvent = this.hasAttribute(Et)),
        (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
        (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
        (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
        (this.keyUpEvent = (t) => this.onKeyUp(t)),
        (this.bodyClickEvent = (t) => this.onBodyClick(t)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popupListMaxWidth();
    }
    onPopupToggleClick(t) {
      const e = "true" === t.currentTarget.getAttribute(ft);
      if (this.productGridItem) {
        const t = this.productGridItem.querySelector(ut);
        t && t.classList.toggle(gt, !e),
          (this.popoutList.style.maxHeight = `${Math.abs(
            this.popoutToggle.getBoundingClientRect().bottom -
              this.productGridItem.getBoundingClientRect().bottom
          )}px`);
      }
      t.currentTarget.setAttribute(ft, !e),
        this.popoutList.classList.toggle(mt),
        this.popupListMaxWidth(),
        this.toggleListPosition(),
        document.body.addEventListener("click", this.bodyClickEvent);
    }
    onPopupToggleFocusout(t) {
      this.contains(t.relatedTarget) || this._hideList();
    }
    onPopupListFocusout(t) {
      const e = t.currentTarget.contains(t.relatedTarget);
      this.popoutList.classList.contains(mt) && !e && this._hideList();
    }
    toggleListPosition() {
      const t = "true" === this.querySelector(lt).getAttribute(ft),
        e = window.innerHeight,
        s = this.popoutList.getBoundingClientRect().bottom,
        i = () => {
          this.classList.remove(yt),
            this.popoutList.removeEventListener("transitionend", i);
        };
      t
        ? e < s && this.classList.add(yt)
        : this.popoutList.addEventListener("transitionend", i);
    }
    popupListMaxWidth() {
      this.popoutList.style.setProperty("--max-width", "100vw"),
        requestAnimationFrame(() => {
          this.popoutList.style.setProperty(
            "--max-width",
            `${parseInt(
              document.body.clientWidth -
                this.popoutList.getBoundingClientRect().left
            )}px`
          );
        });
    }
    popupOptionsClick(t) {
      if ("#" === t.target.closest(dt).attributes.href.value) {
        t.preventDefault();
        const e = t.currentTarget.hasAttribute(wt)
          ? t.currentTarget.getAttribute(wt)
          : "";
        if (
          ((this.popoutInput.value = e),
          this.popoutInput.disabled &&
            this.popoutInput.removeAttribute("disabled"),
          this.fireSubmitEvent)
        )
          this._submitForm(e);
        else {
          const s = t.currentTarget.parentElement,
            i = this.popoutList.querySelector(`.${vt}`),
            o = this.popoutList.querySelector(`[${bt}]`);
          this.popoutInput.dispatchEvent(new Event("change")),
            i && (i.classList.remove(vt), s.classList.add(vt)),
            "quantity" != this.popoutInput.name ||
              s.nextSibling ||
              this.classList.add(vt),
            o &&
              o.hasAttribute(`${bt}`) &&
              (o.removeAttribute(`${bt}`),
              t.currentTarget.setAttribute(`${bt}`, "true")),
            "" !== e &&
              ((this.popoutToggleText.innerHTML = e),
              this.popoutToggleText.hasAttribute(St) &&
                "" !== this.popoutToggleText.getAttribute(St) &&
                this.popoutToggleText.setAttribute(St, e)),
            this.onPopupToggleFocusout(t),
            this.onPopupListFocusout(t);
        }
      }
    }
    onKeyUp(t) {
      "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
    }
    onBodyClick(t) {
      const e = this.contains(t.target);
      this.popoutList.classList.contains(mt) && !e && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((t) => {
          t.addEventListener("click", (t) => this.popupOptionsClick(t));
        });
    }
    _onFocusOut() {
      this.addEventListener("keyup", this.keyUpEvent),
        this.popoutToggle.addEventListener(
          "focusout",
          this.popupToggleFocusoutEvent
        ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusoutEvent
        );
    }
    _submitForm() {
      const t = this.closest("form");
      t && t.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(mt),
        this.popoutToggle.setAttribute(ft, !1),
        this.toggleListPosition(),
        document.body.removeEventListener("click", this.bodyClickEvent);
    }
  }
  class kt extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.input = this.querySelector("input")),
        (this.changeEvent = new Event("change", { bubbles: !0 })),
        (this.buttonClickEvent = this.onButtonClick.bind(this)),
        (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
        this.input.addEventListener("change", this.onQuantityChangeEvent),
        this.querySelectorAll("button").forEach((t) =>
          t.addEventListener("click", this.buttonClickEvent)
        );
    }
    onButtonClick(t) {
      t.preventDefault();
      const e = this.input.value,
        s =
          "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
      "increase" === s.name && this.input.stepUp(),
        "decrease" === s.name && this.input.stepDown(),
        e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
    onQuantityChange() {
      "updates[]" == this.input.name && this.updateCart();
    }
    updateCart() {
      "" !== this.quantityValue &&
        this.dispatchEvent(
          new CustomEvent("theme:cart:update", {
            bubbles: !0,
            detail: { id: this.input.dataset.id, quantity: this.input.value },
          })
        );
    }
  }
  const At = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
      aosIndividual: "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    },
    Ct = "aos-animate",
    Tt = { attributes: !1, childList: !0, subtree: !0 };
  let qt = [];
  const xt = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(At.aos),
            i = t.querySelectorAll(At.aosAnchor);
          s.length &&
            s.forEach((t) => {
              Pt.observe(t);
            }),
            i.length && It(i);
        }
    },
    Pt = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(Ct), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    Mt = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(At.aos);
            s.length &&
              s.forEach((t) => {
                t.classList.add(Ct);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function It(t) {
    t.length &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === qt.indexOf(e)) {
          const t = document.querySelector(e);
          t && (Mt.observe(t), qt.push(e));
        }
      });
  }
  const Ht = "[data-deferred-media-button]",
    Ot = "video, model-viewer, iframe",
    Dt = '[data-host="youtube"]',
    Bt = '[data-host="vimeo"]',
    _t = "[data-grid-item]",
    Ft = ".shopify-section",
    $t = "template",
    Nt = "video",
    Wt = "product-model",
    Rt = "loaded",
    zt = "autoplay";
  class Ut extends HTMLElement {
    constructor() {
      super();
      const t = this.querySelector(Ht);
      t?.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(Ft)),
        (this.productGridItem = this.closest(_t)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(Rt) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(Rt)) {
        const t = this.querySelector(Dt),
          e = this.querySelector(Bt),
          s = t || e,
          i = this.querySelector(Nt);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Rt))) {
        const e = document.createElement("div"),
          s = this.querySelector($t).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(Rt, !0);
        const i = this.appendChild(e.querySelector(Ot));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(zt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(Dt).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(Bt).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Nt).forEach((t) => t.pause()),
        document.querySelectorAll(Wt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
  }
  const Vt = "is-visible";
  class jt {
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
    init() {
      const t = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(Vt)
            : t.target.classList.remove(Vt);
        });
      }, t)),
        this.container.querySelectorAll(this.itemSelector)?.forEach((t) => {
          this.observer.observe(t);
        });
    }
    destroy() {
      this.observer.disconnect();
    }
  }
  const Xt = "is-dragging",
    Jt = "is-enabled",
    Yt = "is-scrolling",
    Qt = "is-visible",
    Gt = "[data-grid-item]";
  class Kt {
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(Jt);
    }
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(Xt, Yt),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(Yt);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(Xt),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${Gt}.${Qt}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(Yt),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(Jt),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
  }
  const Zt = "[data-button-arrow]",
    te = "[data-collection-image]",
    ee = "[data-column-image]",
    se = "[data-product-image]",
    ie = "[data-grid-item]",
    oe = "[data-grid-slider]",
    ne = "data-button-prev",
    re = "data-button-next",
    ae = "align-arrows",
    le = "slider__arrows",
    ce = "is-visible",
    he = "scroll-snap-disabled";
  class de extends HTMLElement {
    constructor() {
      super(),
        (this.isInitialized = !1),
        (this.draggableSlider = null),
        (this.positionArrows = this.positionArrows.bind(this)),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.slidesObserver = null),
        (this.firstLastSlidesObserver = null),
        (this.isDragging = !1),
        (this.toggleSlider = this.toggleSlider.bind(this));
    }
    connectedCallback() {
      this.init(), this.addEventListener("theme:grid-slider:init", this.init);
    }
    init() {
      var t;
      (this.slider = this.querySelector(oe)),
        (this.slides = this.querySelectorAll(ie)),
        (this.buttons = this.querySelectorAll(Zt)),
        this.slider.classList.add(he),
        this.toggleSlider(),
        document.addEventListener("theme:resize:width", this.toggleSlider),
        ((t = this),
        new Promise((e) => {
          const s = t.querySelectorAll("[data-aos]");
          let i = 0;
          function o(t) {
            i++,
              i === s.length && e(),
              t.target.removeEventListener("animationend", o);
          }
          s.forEach((t) => {
            t.addEventListener("animationend", o);
          });
        })).then(() => {
          this.slider.classList.remove(he);
        });
    }
    toggleSlider() {
      if (
        !(this.slider.clientWidth < this.getSlidesWidth()) ||
        (!v() && window.theme.touch)
      )
        this.destroy();
      else {
        if (this.isInitialized) return;
        (this.slidesObserver = new jt(this.slider, ie)),
          this.initArrows(),
          (this.isInitialized = !0),
          (this.draggableSlider = new Kt(this.slider));
      }
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(le),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.append(t),
          (this.buttons = this.querySelectorAll(Zt)),
          (this.buttonPrev = this.querySelector(`[${ne}]`)),
          (this.buttonNext = this.querySelector(`[${re}]`));
      }
      this.toggleArrowsObserver(),
        this.hasAttribute(ae) &&
          (this.positionArrows(), this.arrowsResizeObserver()),
        this.buttons.forEach((t) => {
          t.addEventListener("click", this.onButtonArrowClick);
        });
    }
    buttonArrowClickEvent(t) {
      t.preventDefault();
      const e = this.slider.querySelector(`${ie}.${ce}`);
      let s = null;
      t.target.hasAttribute(ne) && (s = e?.previousElementSibling),
        t.target.hasAttribute(re) && (s = e?.nextElementSibling),
        this.goToSlide(s);
    }
    removeArrows() {
      this.querySelector(`.${le}`)?.remove();
    }
    goToSlide(t) {
      t &&
        this.slider.scrollTo({
          top: 0,
          left: t.offsetLeft,
          behavior: "smooth",
        });
    }
    getSlidesWidth() {
      return (
        this.slider.querySelector(ie)?.clientWidth *
        this.slider.querySelectorAll(ie).length
      );
    }
    toggleArrowsObserver() {
      if (this.buttonPrev && this.buttonNext) {
        const t = this.slides.length,
          e = this.slides[0],
          s = this.slides[t - 1],
          i = { attributes: !0, childList: !1, subtree: !1 },
          o = (t) => {
            for (const i of t)
              if ("attributes" === i.type) {
                const t = i.target,
                  o = Boolean(t.classList.contains(ce));
                t == e && (this.buttonPrev.disabled = o),
                  t == s && (this.buttonNext.disabled = o);
              }
          };
        e &&
          s &&
          ((this.firstLastSlidesObserver = new MutationObserver(o)),
          this.firstLastSlidesObserver.observe(e, i),
          this.firstLastSlidesObserver.observe(s, i));
      }
    }
    positionArrows() {
      const t =
        this.slider.querySelector(se) ||
        this.slider.querySelector(te) ||
        this.slider.querySelector(ee) ||
        this.slider;
      t &&
        this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
    }
    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }
    disconnectedCallback() {
      this.destroy(),
        document.removeEventListener("theme:resize:width", this.toggleSlider);
    }
    destroy() {
      (this.isInitialized = !1),
        this.draggableSlider?.destroy(),
        (this.draggableSlider = null),
        this.slidesObserver?.destroy(),
        (this.slidesObserver = null),
        this.removeArrows(),
        document.removeEventListener("theme:resize:width", this.positionArrows);
    }
  }
  const ue = "time",
    pe = "[data-days]",
    me = "[data-hours]",
    ge = "[data-minutes]",
    ve = "[data-seconds]",
    ye = ".shopify-section",
    fe = "[data-countdown-block]",
    be = "[data-ticker-text]",
    we = "data-expiration-behavior",
    Se = "data-clone",
    Ee = "show-message",
    Le = "hidden",
    ke = "hide-section",
    Ae = "show-message";
  class Ce extends HTMLElement {
    constructor() {
      super(),
        (this.section = this.closest(ye)),
        (this.countdownParent = this.closest(fe) || this.section),
        (this.expirationBehavior = this.getAttribute(we)),
        (this.time = this.querySelector(ue)),
        (this.days = this.querySelector(pe)),
        (this.hours = this.querySelector(me)),
        (this.minutes = this.querySelector(ge)),
        (this.seconds = this.querySelector(ve)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === ke),
        (this.shouldShowMessage = this.expirationBehavior === Ae),
        (this.update = this.update.bind(this));
    }
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.update(), (this.interval = setInterval(this.update, 1e3)));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= s * this.hoursInMs;
      const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= i * this.minutesInMs;
      return {
        days: e,
        hours: s,
        minutes: i,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      if (
        (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete &&
          (this.countdownParent?.classList.add(Le),
          this.countdownParent?.dispatchEvent(
            new CustomEvent("theme:countdown:hide", {
              detail: { element: this },
              bubbles: !0,
            })
          )),
        this.shouldShowMessage)
      ) {
        if ((this.classList?.add(Ee), this.closest(be).hasAttribute(Se)))
          return;
        this.countdownParent?.dispatchEvent(
          new CustomEvent("theme:countdown:expire", { bubbles: !0 })
        );
      }
    }
    update() {
      const t = new Date().getTime(),
        e = this.endDate - t;
      e < 1e3 && (this.stopTimer(), this.onComplete());
      const s = this.convertTime(e);
      this.render(s);
    }
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(At.aosIndividual);
        t.length &&
          t.forEach((t) => {
            Pt.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(At.aosAnchor);
        t.length && It(t);
      })(),
      new MutationObserver(xt).observe(document.body, Tt),
      document.addEventListener("shopify:section:unload", (t) => {
        const e = "#" + t.target.querySelector("[data-section-id]")?.id,
          s = qt.indexOf(e);
        -1 !== s && qt.splice(s, 1);
      })),
    window.addEventListener(
      "resize",
      p(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          f !== m() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (f = m())),
          b !== g() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (b = g()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > w
                  ? ((E = !0), (S = !1))
                  : t < w
                  ? ((E = !1), (S = !0))
                  : ((S = null), (E = null)),
                  (w = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: S, down: E, position: t },
                      bubbles: !1,
                    })
                  ),
                  S &&
                    !L &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  E &&
                    !k &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (k = E),
                  (L = S);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", C),
        window.addEventListener("theme:scroll:unlock", T);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    c(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(I) &&
          (t.target.classList.remove(I),
          t.target.parentNode.classList.remove(I),
          t.target.parentNode.parentNode.classList.contains(I) &&
            t.target.parentNode.parentNode.classList.remove(I));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      l(),
        M(document),
        n(document),
        P(document),
        document.querySelectorAll(H).forEach((t) => {
          t.complete &&
            (t.classList.remove(I),
            t.parentNode.classList.remove(I),
            t.parentNode.parentNode.classList.contains(I) &&
              t.parentNode.parentNode.classList.remove(I));
        }),
        document.body.classList.add("is-loaded"),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      n(e), P(e), M(document), l();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Lt),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", kt),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", rt),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", Ut),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", de),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", Ce);
  const Te = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      target: "api-product-grid-item",
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = encodeURIComponent(t.join(" "));
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = decodeURIComponent(e).split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n, l, c) => {
        s.length && e < c
          ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
              .then((t) => t.text())
              .then((t) => {
                const i = 100 * e,
                  r = o.id ? `#${o.id}` : "",
                  h = document.createElement("div");
                let d = t;
                (d = d.includes("||itemAnimationDelay||")
                  ? d.replaceAll("||itemAnimationDelay||", i)
                  : d),
                  (d = d.includes("||itemAnimationAnchor||")
                    ? d.replaceAll("||itemAnimationAnchor||", r)
                    : d),
                  (h.innerHTML = d),
                  (o.innerHTML +=
                    h.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n, l, c);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n, l, c);
              })
          : ((e, s) => {
              Te(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const qe = "is-focused",
    xe = "[data-skip-content]",
    Pe = 'a[href="#"]';
  window.accessibility = new (class {
    constructor() {
      this.init();
    }
    init() {
      (this.a11y = N),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(xe)),
        (this.linkesWithOnlyHash = document.querySelectorAll(Pe)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(qe);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(qe);
        });
    }
  })();
  function Me(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let s = "";
    const i = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "R${{amount}}";
    function n(t, e = 2, s = ",", i = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) +
        (o[1] ? i + o[1] : "")
      );
    }
    switch (o.match(i)[1]) {
      case "amount":
        s = n(t, 2);
        break;
      case "amount_no_decimals":
        s = n(t, 0);
        break;
      case "amount_with_comma_separator":
        s = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        s = n(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        s = n(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        s = n(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        s = n(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        s = n(t, 2, " ", ".");
    }
    return o.replace(i, s);
  }
  const Ie = (t, e) => {
    let s, i;
    return function o(...n) {
      const r = Date.now();
      (i = clearTimeout(i)),
        !s || r - s >= e
          ? (t.apply(null, n), (s = r))
          : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
    };
  };
  function He(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  He.prototype = Error.prototype;
  const Oe = "is-animated",
    De = "is-added",
    Be = "is-disabled",
    _e = "is-empty",
    Fe = "is-hidden",
    $e = "is-hiding",
    Ne = "is-loading",
    We = "is-open",
    Re = "is-removed",
    ze = "is-success",
    Ue = "is-visible",
    Ve = "is-expanded",
    je = "is-updated",
    Xe = "variant--soldout",
    Je = "variant--unavailable",
    Ye = "[data-api-content]",
    Qe = "[data-api-line-items]",
    Ge = "[data-api-upsell-items]",
    Ke = "[data-api-cart-price]",
    Ze = "[data-animation]",
    ts = "[data-skip-upsell-product]",
    es = "[data-add-to-cart-bar]",
    ss = "[data-cart-error-close]",
    is = "cart-drawer",
    os = "[data-cart-drawer-close]",
    ns = "[data-cart-empty]",
    rs = "[data-cart-errors]",
    as = "[data-item-remove]",
    ls = "[data-cart-page]",
    cs = "[data-cart-form]",
    hs = "[data-cart-acceptance-checkbox]",
    ds = "[data-cart-checkout-buttons]",
    us = "[data-cart-checkout-button]",
    ps = "[data-cart-total]",
    ms = "[data-checkout-buttons]",
    gs = "[data-error-message]",
    vs = "[data-close-error]",
    ys = "[data-cart-errors-container]",
    fs = "[data-form-wrapper]",
    bs = "[data-free-shipping]",
    ws = "[data-progress-graph]",
    Ss = "[data-progress-bar]",
    Es = "[data-header-wrapper]",
    Ls = "[data-item]",
    ks = "[data-items-holder]",
    As = "[data-left-to-spend]",
    Cs = "[data-drawer]",
    Ts = "[data-section-id]",
    qs = "[data-cart-price-holder]",
    xs = "[data-quick-add-holder]",
    Ps = "[data-quick-add-modal]",
    Ms = 'input[name="updates[]"]',
    Is = "[data-upsell-products]",
    Hs = "[data-upsell-widget]",
    Os = "[data-terms-error-message]",
    Ds = "[data-collapsible-body]",
    Bs = "recently-viewed-products-cart",
    _s = "data-cart-total",
    Fs = "disabled",
    $s = "data-free-shipping",
    Ns = "data-free-shipping-limit",
    Ws = "data-item",
    Rs = "data-item-index",
    zs = "data-item-title",
    Us = "open",
    Vs = "data-quick-add-holder",
    js = "data-scroll-locked",
    Xs = "data-upsell-auto-open";
  class Js extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.cartPage = document.querySelector(ls)),
        (this.cartForm = document.querySelector(cs)),
        (this.cartDrawer = document.querySelector(is)),
        (this.cartEmpty = document.querySelector(ns)),
        (this.cartTermsCheckbox = document.querySelector(hs)),
        (this.cartCheckoutButtonWrapper = document.querySelector(ds)),
        (this.cartCheckoutButton = document.querySelector(us)),
        (this.checkoutButtons = document.querySelector(ms)),
        (this.itemsHolder = document.querySelector(ks)),
        (this.priceHolder = document.querySelector(qs)),
        (this.items = document.querySelectorAll(Ls)),
        (this.cartTotal = document.querySelector(ps)),
        (this.freeShipping = document.querySelectorAll(bs)),
        (this.cartErrorHolder = document.querySelector(rs)),
        (this.cartCloseErrorMessage = document.querySelector(ss)),
        (this.headerWrapper = document.querySelector(Es)),
        (this.navDrawer = document.querySelector(Cs)),
        (this.upsellProductsHolder = document.querySelector(Is)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.giftCart = this.giftCart.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener("theme:cart-drawer:open", this.animateItems),
        document.addEventListener(
          "theme:cart-drawer:close",
          this.onCartDrawerClose
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress,
          this.giftCart,
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(Ns)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.giftCart(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.formSubmitHandler = Ie(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.animateItems(),
          this.recentlyViewedProducts(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.dispatchEvent(
            new CustomEvent("theme:cart:load", { bubbles: !0 })
          ));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:unload", { bubbles: !0 })
        ),
        document.documentElement.hasAttribute(js) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    onCartDrawerClose() {
      this.resetAnimatedItems(),
        this.cartDrawer?.classList.contains(We) &&
          this.cart.classList.remove(je),
        this.cartEmpty.classList.remove(je),
        this.cartErrorHolder.classList.remove(Ve),
        this.cart.querySelectorAll(Ze).forEach((t) => {
          const e = () => {
            t.classList.remove($e), t.removeEventListener("animationend", e);
          };
          t.classList.add($e), t.addEventListener("animationend", e);
        });
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(Ls)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(as).forEach((t) => {
        const e = t.closest(Ls);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(Be) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(Ve);
          });
    }
    cartAddEvent(t) {
      console.log(">>>> cartAddEvent", t);
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      if (!i.checkValidity()) return void i.reportValidity();
      if (
        (console.log(i),
        (e = new FormData(i)),
        console.log(">>>> formData", e),
        null !== i && i.querySelector('[type="file"]'))
      )
        return;
      for (var o of (t.preventDefault(), e.entries()))
        console.log(o[0] + ", " + o[1]);
      const n = document.querySelector("plans-selector");
      n &&
        n.selectedId &&
        (console.log(">>>> plansSelector", n.selectedId),
        e.append("id", n.selectedId)),
        this.addToCart(e, s);
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(hs).checked,
        e = document.querySelector(Os);
      if (t)
        e.classList.remove(Ve), this.cartCheckoutButton.removeAttribute(Fs);
      else {
        if (document.querySelector(Os).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(Fs, !0),
          e.classList.add(Ve);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(vs);
      e?.addEventListener("click", (e) => {
        e.preventDefault(), t && t.classList.remove(Ue);
      });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(Ye);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      console.log(">>>> addToCart"), this.cart && this.cart.classList.add(Ne);
      const s = e?.closest(xs);
      e && (e.classList.add(Ne), (e.disabled = !0)),
        s && s.classList.add(Ue),
        console.log(">>>> addToCart > 1"),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(Ne), (e.disabled = !1)))
              );
            this.cart
              ? (e &&
                  (e.classList.remove(Ne),
                  e.classList.add(De),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
              
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(Ne);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(Ne) : e.classList.add(Re)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${Ws}="${t.id}"]`) || e,
        o = i?.hasAttribute(Rs) ? parseInt(i.getAttribute(Rs)) : 0,
        n = i?.hasAttribute(zs) ? i.getAttribute(zs) : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
            
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(Ms),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(Ne);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${as}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(Be), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(Fs, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${as}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(Be), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(Fs);
          }),
        this.cart.classList.remove(Ne);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(gs).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(Ve, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new He({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      if (null !== e) {
        const s = e.closest(Ts) || e.closest(xs) || e.closest(Ps);
        let i = s?.querySelector(ys);
        const o = e.closest(xs);
        if ((o && o.querySelector(ys) && (i = o.querySelector(ys)), i)) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(Ue),
            this.formErrorsEvents(i);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: { response: t, button: e },
            bubbles: !0,
          })
        );
      }
      const s = e?.closest(xs);
      s &&
        s.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: s,
            },
          })
        ),
        this.cart?.classList.remove(Ne);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(es);
      e.push(o),
        (s = o.closest(xs)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(Ne), i || t.classList.add(De);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            t.classList.remove(De);
            t.closest(fs)?.classList.contains(Xe) ||
              t.closest(fs)?.classList.contains(Je) ||
              (t.disabled = !1);
          }),
            s?.classList.remove(Ue);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle(_e, !t),
        t ||
          setTimeout(() => {
            _(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(os),
            });
          }, 100);
    }
    build(t) {
      const e = t.querySelector(Qe),
        s = t.querySelector(Ge),
        i = Boolean(null === e && null === s),
        o = t.querySelector(Ke),
        n = t.querySelector(ps);
      this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
        i
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = s.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          e && e.querySelectorAll(Ls).length
            ? e.querySelectorAll(Ls).length
            : 0),
        (this.subtotal =
          n && n.hasAttribute(_s) ? parseInt(n.getAttribute(_s)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : Me(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawer?.classList.contains(We) && this.cart.classList.add(je),
        this.cart.classList.remove(Ne),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(Ze).forEach((t) => {
            t.classList.remove(Oe);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        this.giftCart(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    giftCart() {
      const cart = this.cart;
      const cartItemsContainer = this;
      const cartPriceEl = cart.querySelector('[data-cart-total]');
      const totalCartValue = parseFloat(cartPriceEl.getAttribute('data-cart-subtotal') ?? cartPriceEl.getAttribute('data-cart-total')) / 100;
    
      const cartItems = Array.from(cart.querySelectorAll('.cart__item'));
      const giftList = window.vhita?.gift || [];
      const freeShippingMinValue = window.vhita?.freeShippingMinValue || 0;
    
      const milestones = [
        { type: "shipping", minValue: freeShippingMinValue },
        ...giftList
          .filter(g => g?.id)
          .map(gift => ({ type: "gift", id: gift.id, label: gift.label, minValue: gift.minValue || 0 }))
      ];
    
      function updateBarProgress() {
        const progress = document.querySelector('.free-shipping-gift');
        if (!progress) return;
      
        const barFill = progress.querySelector('#progressBar');
        const milestoneEls = progress.querySelectorAll('.item-circle');
      
        const maxThreshold = Math.max(...milestones.map(m => m.minValue));
        const percent = Math.min(totalCartValue / maxThreshold, 1);
        barFill.style.width = `${percent * 100}%`;
      
        milestoneEls.forEach(el => {
          const minValue = parseFloat(el.dataset.minvalue);
          const percentPosition = (minValue / maxThreshold) * 100;
          el.style.left = `${percentPosition}%`;
          el.classList.toggle('reached', totalCartValue >= minValue);
        });
      
        updateInfoMessage();
      }
    
      function updateInfoMessage() {
        const infoMessages = document.querySelectorAll('#infoMessage, .progress-bar-section__text');
        if (!infoMessages.length) return;

        // Lê os templates configurados pelo lojista no Customizer (settings).
        // Fallback para os textos padrão caso o snippet não esteja renderizado.
        const cfgEl = document.querySelector('.progress-info');
        const cfg = (cfgEl && cfgEl.dataset) || {};
        const tpl = {
          next: cfg.msgNext || 'Adicione <strong>{amount}</strong> e ganhe <strong>{next}</strong>.',
          achievedShippingAndGifts: cfg.msgAchievedShippingAndGifts || '🎉 <strong>Frete</strong> e <strong>{gifts}</strong> garantidos! ',
          achievedShipping: cfg.msgAchievedShipping || '🎉 <strong>Frete</strong> garantido! ',
          achievedGifts: cfg.msgAchievedGifts || '🎉 <strong>{gifts}</strong> garantido{plural}! ',
          complete: cfg.msgComplete || '🎉 Parabéns! Você ganhou <strong>{gifts}</strong> e <strong>Frete Grátis</strong>!',
          freeShippingLabel: cfg.labelFreeShipping || 'Frete Grátis'
        };

        // Substitui placeholders {chave} pelos valores reais.
        const fmt = (template, vars) =>
          template.replace(/\{(\w+)\}/g, (_, key) => (vars[key] != null ? vars[key] : ''));

        // Ordena marcos por valor para garantir a progressão correta.
        const sortedMilestones = [...milestones].sort((a, b) => a.minValue - b.minValue);

        // Próximo valor a atingir (threshold único, não o objeto isolado).
        const nextThreshold = sortedMilestones.find(m => totalCartValue < m.minValue)?.minValue;
        const achievedMilestones = sortedMilestones.filter(m => totalCartValue >= m.minValue);
        const hasFreeShipping = totalCartValue >= freeShippingMinValue;

        if (nextThreshold != null) {
          const amountToNext = nextThreshold - totalCartValue;
          const formattedAmount = amountToNext.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          });

          // Agrupa todos os marcos nesse threshold (ex: frete + brinde ao mesmo tempo).
          const nextGroup = sortedMilestones.filter(m => m.minValue === nextThreshold);
          const nextHasShipping = nextGroup.some(m => m.type === "shipping");
          const nextGiftLabels = nextGroup.filter(m => m.type === "gift").map(m => m.label);

          let nextLabel;
          if (nextHasShipping && nextGiftLabels.length > 0) {
            nextLabel = tpl.freeShippingLabel + ' + ' + nextGiftLabels.join(' + ');
          } else if (nextHasShipping) {
            nextLabel = tpl.freeShippingLabel;
          } else {
            nextLabel = nextGiftLabels.join(' + ');
          }

          const achievedGifts = achievedMilestones
            .filter(m => m.type !== "shipping")
            .map(m => m.label);

          const giftsHtml = achievedGifts.join("</strong> e <strong>");

          let achievedText = "";

          if (hasFreeShipping && achievedGifts.length > 0) {
            achievedText = fmt(tpl.achievedShippingAndGifts, { gifts: giftsHtml });
          } else if (hasFreeShipping) {
            achievedText = tpl.achievedShipping;
          } else if (achievedGifts.length > 0) {
            achievedText = fmt(tpl.achievedGifts, {
              gifts: giftsHtml,
              plural: achievedGifts.length > 1 ? "s" : ""
            });
          }

          const nextText = fmt(tpl.next, { amount: formattedAmount, next: nextLabel });
          const messageHtml = `${achievedText}${nextText}`;
          infoMessages.forEach((infoMessage) => {
            infoMessage.innerHTML = messageHtml;
          });

        } else {
          const allGifts = sortedMilestones
            .filter(m => m.type !== "shipping")
            .map(m => m.label);

          const messageHtml = fmt(tpl.complete, {
            gifts: allGifts.join("</strong> e <strong>")
          });
          infoMessages.forEach((infoMessage) => {
            infoMessage.innerHTML = messageHtml;
          });
        }
      }
    
      updateBarProgress();
    
      const isGiftInCart = (giftID) => {
        return cartItems.some(item => {
          const itemID = parseInt(item.dataset.item.split(':')[0]);
          return itemID === giftID;
        });
      };
    
      function addGiftToCart(gift) {

        if (isGiftInCart(gift.id)) {
          // console.log(`Brinde ${gift.id} já está no carrinho, não será adicionado novamente.`);
          return;
        }
    
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: gift.id, quantity: 1 })
        })
        .then(() => cartItemsContainer.getCart())
        .catch(err => console.error("Erro ao adicionar o brinde:", err));
      }
    
      milestones
        .filter(m => m.type === "gift")
        .forEach(gift => {
          if (totalCartValue >= gift.minValue) {
            addGiftToCart(gift);
          }
        }); 

    
      cartItems.forEach(item => { 
        const itemID = parseInt(item.dataset.item.split(':')[0]);
        const gift = milestones.find(m => m.type === "gift" && m.id === itemID);
    
        if (gift && totalCartValue < gift.minValue) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.dataset.item, quantity: 0 })
          })
          .then(() => cartItemsContainer.getCart())
          .catch(err => console.error("Erro ao remover o brinde:", err));
        }
      });
    }
    updateGiftCart(item, qtd){
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item,
          quantity: qtd
        })
      })
      .then(response => response.json())
      .then(cart => {
        this.getCart();
      })
      .catch(error => {
          console.error("Erro ao alterar o produto no carrinho:", error);
      });       
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(Ms)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute($s) && "true" === e.getAttribute($s) && t >= 0;
          e.classList.toggle(ze, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(bs)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        s = this.circumference - ((e / 100) * this.circumference) / 2,
        i = Me(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
      this.freeShipping.forEach((t) => {
        const o = t.querySelector(Ss),
          n = t.querySelector(ws),
          r = t.querySelector(As);
        r && (r.innerHTML = i.replace(".00", "")),
          o &&
            (o.value = e,
            o.style.setProperty("--progress-percent", `${e}%`),
            o.classList.toggle("is-full", e >= 100)),
          n && n.style.setProperty("--stroke-dashoffset", `${s}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(ts);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(xs).getAttribute(Vs);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${Vs}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(xs),
        e = this.upsellProductsHolder.closest(Hs);
      if (
        e &&
        (e.classList.toggle(Fe, !t.length),
        t.length && !e.hasAttribute(Us) && e.hasAttribute(Xs))
      ) {
        e.setAttribute(Us, !0);
        const t = e.querySelector(Ds);
        t && (t.style.height = "auto");
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(Ze).forEach((t) => {
        t.classList.remove(Oe), t.classList.remove($e);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          e?.querySelectorAll(Ze).forEach((t) => {
            t.classList.add(Oe);
          });
      });
    }
    recentlyViewedProducts() {
      this.cart.querySelector(`#${Bs}`) &&
        Shopify.Products.showRecentlyViewed({
          howManyToShow: 3,
          wrapperId: Bs,
          section: this,
          target: "api-upsell-product",
        });
    }
  }
  customElements.get("cart-items") || customElements.define("cart-items", Js);
  const Ys = "data-cart-count",
    Qs = "data-limit";
  class Gs extends HTMLElement {
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(Qs)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(Ys, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
  }
  function Ks(t) {
    return new Promise((e) => {
      t?.addEventListener("animationend", function s(i) {
        i.target == t && (t.removeEventListener("animationend", s), e());
      });
    });
  }
  customElements.get("cart-count") || customElements.define("cart-count", Gs);
  const Zs = "is-open",
    ti = "is-closing",
    ei = "drawer--duplicate",
    si = "drawer-editor-error",
    ii = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    oi = "data-drawer-underlay";
  class ni extends HTMLElement {
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(ii.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(ii.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(ii.shopifySection)),
        this.closeCartEvents();
    }
    connectedCallback() {
      const t = this.closest(ii.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(si),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${si}`) ||
              this.querySelector(ii.cartDrawerInner).append(t),
            this.classList.add(ei);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(ii.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(ii.shopifySection) ||
        t.target.closest(ii.shopifySection) ||
        t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(ei)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: { target: this },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.classList.add(Zs),
        this.observeAdditionalCheckoutButtons(),
        Ks(this.cartDrawerInner).then(() => {
          _(this, { elementToFocus: this.querySelector(ii.cartDrawerClose) });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(Zs) &&
        (this.classList.add(ti),
        this.classList.remove(Zs),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })
        ),
        F(),
        $(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        Ks(this.cartDrawerInner).then(() => {
          this.classList.remove(ti);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(oi) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(ii.additionalCheckoutButtons);
      if (t) {
        const e = new MutationObserver(() => {
          _(this, { elementToFocus: this.querySelector(ii.cartDrawerClose) }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
  }
  customElements.get("cart-drawer") || customElements.define("cart-drawer", ni);
  const ri = "[data-collapsible]",
    ai = "[data-collapsible-trigger]",
    li = "[data-collapsible-body]",
    ci = "[data-collapsible-content]",
    hi = "desktop",
    di = "disabled",
    ui = "mobile",
    pi = "open",
    mi = "single";
  class gi extends HTMLElement {
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(ri)),
        (this.single = this.hasAttribute(mi)),
        (this.toggle = this.toggle.bind(this));
    }
    connectedCallback() {
      this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          const e = t.querySelector(ai),
            s = t.querySelector(li);
          e?.addEventListener("click", (t) => this.onCollapsibleClick(t)),
            s.addEventListener("transitionend", (e) => {
              e.target === s &&
                ("true" == t.getAttribute(pi) && this.setBodyHeight(s, "auto"),
                "false" == t.getAttribute(pi) &&
                  (t.removeAttribute(pi), this.setBodyHeight(s, "")));
            });
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle);
    }
    toggle() {
      const t = v();
      this.collapsibles.forEach((e) => {
        const s = e.hasAttribute(hi) ? e.getAttribute(hi) : "true",
          i = e.hasAttribute(ui) ? e.getAttribute(ui) : "true",
          o = e.querySelector(li);
        (t && "true" == s) || (!t && "true" == i)
          ? (e.querySelector(ai).removeAttribute("tabindex"),
            e.removeAttribute(pi),
            e.removeAttribute(di),
            this.setBodyHeight(o, ""))
          : (e.setAttribute(di, ""),
            e.setAttribute("open", !0),
            e.querySelector(ai).setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(li),
        s = t.querySelector(ci);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(li),
        s = t.querySelector(ci);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = t.target.closest(ri);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(pi) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(pi) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
  }
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", gi);
  const vi = "details",
    yi = "[data-popdown]",
    fi = "[data-popdown-close]",
    bi = 'input:not([type="hidden"])',
    wi = "data-popdown-underlay",
    Si = "is-open";
  class Ei extends HTMLElement {
    constructor() {
      super(),
        (this.popdown = this.querySelector(yi)),
        (this.popdownContainer = this.querySelector(vi)),
        (this.popdownClose = this.querySelector(fi)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.a11y = N);
    }
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(Si)
          ? "transform" === t.propertyName &&
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(bi),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(wi)) || this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          this.classList.add(Si);
        });
    }
    close() {
      this.classList.remove(Si),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
  }
  customElements.define("header-search-popdown", Ei);
  const Li = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends V {
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(Li)),
          this.setupEventListeners();
      }
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        v() || this.scrollIntoView({ behavior: "smooth" });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
    }
  );
  const ki = "[data-actions]",
    Ai = "[data-content]",
    Ci = "[data-button]",
    Ti = "data-height",
    qi = "is-open",
    xi = "is-enabled";
  class Pi extends HTMLElement {
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(Ti)),
        (this.content = this.querySelector(Ai)),
        (this.trigger = this.querySelector(Ci)),
        (this.actions = this.querySelector(ki)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(qi);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        xi,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
  }
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", Pi);
  const Mi = ".template-addresses",
    Ii = "#AddressNewForm",
    Hi = ".address-new-toggle",
    Oi = ".address-edit-toggle",
    Di = ".address-delete",
    Bi = "data-form-id",
    _i = "data-confirm-message",
    Fi = "#EditAddress",
    $i = "AddressCountryNew",
    Ni = "AddressProvinceNew",
    Wi = "AddressProvinceContainerNew",
    Ri = ".address-country-option",
    zi = "AddressCountry",
    Ui = "AddressProvince",
    Vi = "AddressProvinceContainer",
    ji = "hidden";
  class Xi {
    constructor(t) {
      (this.section = t),
        (this.addressNewForm = this.section.querySelector(Ii)),
        this.init();
    }
    init() {
      if (this.addressNewForm) {
        const t = this.section,
          e = this.addressNewForm;
        this.customerAddresses();
        const s = t.querySelectorAll(Hi);
        s.length &&
          s.forEach((t) => {
            t.addEventListener("click", function () {
              e.classList.toggle(ji);
            });
          });
        const i = t.querySelectorAll(Oi);
        i.length &&
          i.forEach((e) => {
            e.addEventListener("click", function () {
              const e = this.getAttribute(Bi);
              t.querySelector(`${Fi}_${e}`).classList.toggle(ji);
            });
          });
        const o = t.querySelectorAll(Di);
        o.length &&
          o.forEach((t) => {
            t.addEventListener("click", function () {
              const t = this.getAttribute(Bi),
                e = this.getAttribute(_i);
              confirm(e) &&
                Shopify.postLink(window.theme.routes.addresses_url + "/" + t, {
                  parameters: { _method: "delete" },
                });
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector($i, Ni, { hideElement: Wi });
      this.section.querySelectorAll(Ri).forEach((t) => {
        const e = t.getAttribute(Bi),
          s = `${zi}_${e}`,
          i = `${Ui}_${e}`,
          o = `${Vi}_${e}`;
        new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
      });
    }
  }
  const Ji = document.querySelector(Mi);
  Ji && new Xi(Ji);
  const Yi = ".customer-logged-in",
    Qi = ".account",
    Gi = ".account-sidebar--mobile";
  class Ki {
    constructor(t) {
      (this.section = t), this.init();
    }
    init() {
      this.section.querySelector(Qi) && this.accountMobileSidebar();
    }
    accountMobileSidebar() {
      this.section.querySelector(Gi) &&
        this.section.querySelector(Gi).addEventListener("click", function () {
          const t = this.nextElementSibling;
          t && "UL" === t.tagName && t.classList.toggle("visible");
        });
    }
  }
  const Zi = document.querySelector(Yi);
  Zi && new Ki(Zi);
  const to = "[data-account-form]",
    eo = "[data-show-reset]",
    so = "[data-hide-reset]",
    io = "[data-recover-password]",
    oo = "[data-recover-success]",
    no = "[data-login-form]",
    ro = "#recover",
    ao = "is-hidden";
  class lo {
    constructor(t) {
      (this.form = t),
        (this.showButton = t.querySelector(eo)),
        (this.hideButton = t.querySelector(so)),
        (this.recover = t.querySelector(io)),
        (this.recoverSuccess = t.querySelector(oo)),
        (this.login = t.querySelector(no)),
        this.init();
    }
    init() {
      window.location.hash == ro || this.recoverSuccess
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.showButton.addEventListener(
          "click",
          function (t) {
            t.preventDefault(), this.showRecoverPasswordForm();
          }.bind(this),
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          function (t) {
            t.preventDefault(), this.hideRecoverPasswordForm();
          }.bind(this),
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.login.classList.add(ao),
        this.recover.classList.remove(ao),
        (window.location.hash = ro),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.recover.classList.add(ao),
        this.login.classList.remove(ao),
        (window.location.hash = ""),
        !1
      );
    }
  }
  const co = document.querySelector(to);
  co && new lo(co),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const ho = window.Shopify.theme.sections.registered,
    uo = window.Shopify.theme.sections.instances,
    po = "data-section-id",
    mo = "data-section-type";
  class go {
    constructor(t = null, e = []) {
      (this.type = t),
        (this.components = (function (t) {
          if ((void 0 !== t && "object" != typeof t) || null === t)
            throw new TypeError(
              "Theme Sections: The components object provided is not a valid"
            );
          return t;
        })(e)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        e.forEach((t) => {
          for (const [e, s] of Object.entries(t)) {
            const t = this.callStack[e];
            Array.isArray(t) && "function" == typeof s
              ? t.push(s)
              : (console.warn(
                  `Unregisted function: '${e}' in component: '${this.type}'`
                ),
                console.warn(s));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class vo {
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(po))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              po +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(po)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = { id: this.id, type: this.type, container: this.container };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
  }
  function yo(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== ho[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new go(t, e);
    return (ho[t] = s), ho;
  }
  function fo(t, e) {
    (t = So(t)),
      void 0 === e && (e = document.querySelectorAll("[" + mo + "]")),
      (e = Eo(e)),
      t.forEach(function (t) {
        const s = ho[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(bo(e).length > 0) &&
              null !== e.getAttribute(mo) &&
              (e.getAttribute(mo) !== t || (uo.push(new vo(e, s)), !1))
            );
          }));
      });
  }
  function bo(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      Eo(t).forEach(function (t) {
        e = e.concat(
          uo.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      So(t).forEach(function (t) {
        e = e.concat(
          uo.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function wo(t) {
    for (var e, s = 0; s < uo.length; s++)
      if (uo[s].id === t) {
        e = uo[s];
        break;
      }
    return e;
  }
  function So(t) {
    return (
      "*" === t
        ? (t = Object.keys(ho))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === vo
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === vo &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function Eo(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + po + '="' + e + '"]');
      null !== s && fo(s.getAttribute(mo), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + po + '="' + e + '"]');
      "object" == typeof bo(s)[0] &&
        bo(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + po + '="' + e + '"]');
      "object" == typeof bo(s)[0] &&
        bo(s).forEach(function (t) {
          var e = uo
            .map(function (t) {
              return t.id;
            })
            .indexOf(t.id);
          uo.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Lo = "data-tooltip",
    ko = "data-tooltip-stop-mouseenter",
    Ao = "tooltip-default",
    Co = "is-visible",
    To = "is-hiding";
  let qo = {};
  class xo {
    constructor(t, e = {}) {
      (this.tooltip = t),
        this.tooltip.hasAttribute(Lo) &&
          ((this.label = this.tooltip.getAttribute(Lo)),
          (this.class = e.class || Ao),
          (this.transitionSpeed = e.transitionSpeed || 200),
          (this.hideTransitionTimeout = 0),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (t) => Ie(this.removePin(t), 50)),
          (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
          this.init());
    }
    init() {
      if (!document.querySelector(`.${this.class}`)) {
        const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
          e = document.createElement("div");
        (e.className = this.class),
          (e.innerHTML = t),
          document.body.appendChild(e);
      }
      this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
    }
    addPin(t = !1) {
      const e = document.querySelector(`.${this.class}`);
      if (this.label && e && ((t && !this.tooltip.hasAttribute(ko)) || !t)) {
        const t = e.querySelector(`.${this.class}__arrow`),
          s = e.querySelector(`.${this.class}__inner`);
        e.querySelector(`.${this.class}__text`).innerHTML = this.label;
        const i = s.offsetWidth,
          o = this.tooltip.getBoundingClientRect(),
          n = o.top,
          r = o.width,
          a = n + o.height + window.scrollY;
        let l = o.left - i / 2 + r / 2;
        const c = 24,
          h = l + i - m() + c;
        h > 0 && (l -= h),
          l < 0 && (l = 0),
          (t.style.left = `${o.left + r / 2}px`),
          e.style.setProperty("--tooltip-top", `${a}px`),
          (s.style.transform = `translateX(${l}px)`),
          e.classList.remove(To),
          e.classList.add(Co),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(t, e = !1, s = !1) {
      const i = document.querySelector(`.${this.class}`),
        o = i.classList.contains(Co);
      i &&
        ((e && !this.tooltip.hasAttribute(ko)) || !e) &&
        (o &&
          (s || t.detail.hideTransition) &&
          (i.classList.add(To),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            i.classList.remove(To);
          }, this.transitionSpeed))),
        i.classList.remove(Co),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
  }
  const Po = {
    onLoad() {
      qo[this.id] = [];
      this.container.querySelectorAll(`[${Lo}]`).forEach((t) => {
        qo[this.id].push(new xo(t));
      });
    },
    onUnload: function () {
      qo[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var Mo = {};
  const Io = {
    onLoad() {
      Mo[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const s = t.querySelector("[data-parallax-img]");
          Mo[this.id].push(new e(s, { center: !0, round: !0, frame: t }));
        }),
        window.addEventListener("load", () => {
          Mo[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      Mo[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  yo("article", [Po, Io]);
  const Ho = "[data-aos]",
    Oo = ".collection-item__image",
    Do = "[data-column-image]",
    Bo = ".flickity-button.next",
    _o = ".flickity-button.previous",
    Fo = "a:not(.btn)",
    $o = ".product-item__image",
    No = "[data-slide]",
    Wo = "data-slide",
    Ro = "[data-slider]",
    zo = "[data-slider-thumb]",
    Uo = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    Vo = "aos-animate",
    jo = "desktop",
    Xo = "is-focused",
    Jo = "flickity-enabled",
    Yo = "is-initialized",
    Qo = "is-loading",
    Go = "is-selected",
    Ko = "mobile",
    Zo = "single-slide",
    tn = "js-slider--initialized",
    en = {};
  class sn {
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(Ro)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(No)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(zo)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              Uo.slidesLargeDesktop
            )),
            this.slideshow.hasAttribute(Uo.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(Uo.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
    init() {
      this.slideshow.classList.add(Qo);
      let t = No;
      const e = v(),
        o = `${No}:not(.${Ko})`,
        n = `${No}:not(.${jo})`;
      (this.slideshow.querySelectorAll(n).length ||
        this.slideshow.querySelectorAll(o).length) &&
        (t = e ? o : n),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(Zo),
          this.slideshow.classList.remove(Qo)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(Yo),
                  this.slideshow.classList.remove(Qo),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(Ho);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(Vo),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(Vo);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new i(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new s(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(Qo);
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${Go}`);
      if (!e) return;
      const s = e.hasAttribute(Uo.slideTextColor)
          ? e.getAttribute(Uo.slideTextColor)
          : "",
        i = e.querySelector(Fo),
        o = this.slideshow.querySelectorAll(`${No} a, ${No} button`);
      if (
        (document.body.classList.contains(Xo) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(No);
            if (e) {
              const s = e.classList.contains(Go) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(Uo.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(Uo.slideIndex)),
          s = this.container.querySelector(`${zo}.${Go}`);
        s && s.classList.remove(Go), this.sliderThumbs[t].classList.add(Go);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(Uo.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(Oo) ||
          this.slideshow.querySelector($o) ||
          this.slideshow.querySelector(Do);
        if (!t) return;
        (this.slideshow.querySelector(_o).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(Bo).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${Wo}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(Uo.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(tn) && (s = 0),
        this.slideshow.classList.add(Go),
        this.flkty &&
          this.slideshow.classList.contains(Jo) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(Go),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
  }
  const on = {
    onLoad() {
      en[this.id] = [];
      this.container.querySelectorAll(Ro).forEach((t) => {
        en[this.id].push(new sn(this.container, t));
      });
    },
    onUnload() {
      en[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      en[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      en[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  yo("blog-section", [on]), yo("hero", Io), yo("double", on);
  const nn = (t) => {
    let { stickyHeaderHeight: e } = a();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  class rn {
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
  }
  const an = "[data-newsletter-form]",
    ln = "[data-newsletter-heading]",
    cn = "[data-newsletter]",
    hn = "has-success",
    dn = "has-error",
    un = "hidden",
    pn = "data-cookie-name",
    mn = {};
  class gn {
    constructor(t) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = t),
        (this.popup = this.newsletter.closest(cn)),
        this.popup &&
          (this.cookie = new rn(
            this.popup.getAttribute(pn),
            "user_has_closed",
            null
          )),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(t) {
      this.stopSubmit &&
        (t.preventDefault(),
        t.stopImmediatePropagation(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const t = document.getElementById(this.formID),
          e = t.parentElement.querySelector(ln),
          s = -1 !== window.location.search.indexOf("?customer_posted=true"),
          i = -1 !== window.location.search.indexOf("accepts_marketing");
        s
          ? (t.classList.remove(dn),
            t.classList.add(hn),
            e && (e.classList.add(un), t.classList.remove(un)),
            this.popup && this.cookie.write())
          : i &&
            (t.classList.remove(hn),
            t.classList.add(dn),
            e && (e.classList.add(un), t.classList.remove(un))),
          (s || i) &&
            window.addEventListener("load", () => {
              this.scrollToForm(t);
            });
      }
    }
    scrollToForm(t) {
      const e = t.getBoundingClientRect();
      (e.top >= 0 && e.left >= 0 && e.bottom <= g() && e.right <= m()) ||
        setTimeout(() => {
          nn(t.getBoundingClientRect().top);
        }, 500);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  const vn = {
    onLoad() {
      mn[this.id] = [];
      this.container.querySelectorAll(an).forEach((t) => {
        mn[this.id].push(new gn(t));
      });
    },
    onUnload() {
      mn[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  yo("footer", [Io, vn]);
  const yn = "[data-collection-sidebar]",
    fn = "[data-collection-sidebar-slide-out]",
    bn = "[data-collection-sidebar-close]",
    wn = "[data-aria-toggle]",
    Sn = "drawer--animated",
    En = "expanded",
    Ln = "no-mobile-animation",
    kn = "is-focused";
  let An = {};
  class Cn {
    constructor(t) {
      (this.container = t.container),
        (this.collectionSidebar = this.container.querySelector(yn)),
        (this.groupTagsButton = this.container.querySelector(wn)),
        (this.a11y = N),
        (this.groupTagsButtonClickEvent = (t) => this.groupTagsButtonClick(t)),
        (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
        (this.collectionSidebarCloseEvent = (t) =>
          this.collectionSidebarClose(t)),
        this.init();
    }
    init() {
      if (null !== this.groupTagsButton) {
        document.addEventListener(
          "theme:resize:width",
          this.sidebarResizeEvent
        ),
          this.groupTagsButton.addEventListener(
            "click",
            this.groupTagsButtonClickEvent
          ),
          this.collectionSidebar &&
            setTimeout(() => {
              this.collectionSidebar.classList.remove(Ln);
            }, 1e3);
        new MutationObserver((t) => {
          for (const e of t)
            if ("attributes" === e.type) {
              "true" == e.target.getAttribute("aria-expanded") &&
                this.showSidebarCallback();
            }
        }).observe(this.groupTagsButton, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
      }
      this.container.addEventListener(
        "keyup",
        function (t) {
          "Escape" === t.code && this.hideSidebar();
        }.bind(this)
      ),
        this.collectionSidebar &&
          (this.collectionSidebar.addEventListener("transitionend", () => {
            this.collectionSidebar.classList.contains(En) ||
              this.collectionSidebar.classList.remove(Sn);
          }),
          this.toggleSidebarSlider(),
          this.container.addEventListener(
            "theme:filter:close",
            this.collectionSidebarCloseEvent
          ));
    }
    showSidebarCallback() {
      const t = this.container.querySelector(fn),
        e = document.documentElement.hasAttribute("data-scroll-locked"),
        s = y();
      this.collectionSidebar.classList.add(Sn),
        null === t &&
          !s &&
          e &&
          (this.a11y.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          )),
        (s || null !== t) &&
          (t &&
            this.a11y.trapFocus(this.collectionSidebar, {
              elementToFocus: this.collectionSidebar.querySelector(bn),
            }),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ));
    }
    hideSidebar() {
      const t = this.container.querySelector(fn),
        e = document.documentElement.hasAttribute("data-scroll-locked");
      this.groupTagsButton.setAttribute("aria-expanded", "false"),
        this.collectionSidebar.classList.remove(En),
        t && this.a11y.removeTrapFocus(),
        e &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    toggleSidebarSlider() {
      y()
        ? this.hideSidebar()
        : this.collectionSidebar.classList.contains(En) &&
          this.showSidebarCallback();
    }
    collectionSidebarClose(t) {
      t.preventDefault(),
        this.hideSidebar(),
        document.body.classList.contains(kn) &&
          this.groupTagsButton &&
          this.groupTagsButton.focus();
    }
    groupTagsButtonClick() {
      document.documentElement.hasAttribute("data-scroll-locked") &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    onUnload() {
      null !== this.groupTagsButton &&
        (document.removeEventListener(
          "theme:resize:width",
          this.sidebarResizeEvent
        ),
        this.groupTagsButton.removeEventListener(
          "click",
          this.groupTagsButtonClickEvent
        )),
        this.collectionSidebar &&
          this.container.removeEventListener(
            "theme:filter:close",
            this.collectionSidebarCloseEvent
          );
    }
  }
  yo("collection", [
    on,
    Io,
    {
      onLoad() {
        An[this.id] = new Cn(this);
      },
      onUnload() {
        An[this.id].onUnload();
      },
    },
    Po,
  ]);
  const Tn = "[data-ticker-scale]",
    qn = "[data-ticker-text]",
    xn = "data-clone",
    Pn = "autoplay",
    Mn = "speed",
    In = "ticker--animated",
    Hn = "ticker--unloaded",
    On = "ticker__comparitor",
    Dn = 1.63,
    Bn = 100;
  class _n extends HTMLElement {
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(Pn)),
        (this.scale = this.querySelector(Tn)),
        (this.text = this.querySelector(qn)),
        (this.speed = this.hasAttribute(Mn) ? this.getAttribute(Mn) : Dn),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(On),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(Hn),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener(
          "theme:ticker:refresh",
          p(() => this.checkWidthEvent(), 50)
        ),
        screen.orientation.addEventListener("change", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      this.text = this.querySelector(qn);
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
        e = this.clientWidth - t < this.comparitor.clientWidth;
      if (e || this.autoplay) {
        this.text.classList.remove(In);
        const s = this.scale.querySelectorAll(`[${xn}]`),
          i = this.autoplay
            ? parseInt((window.innerWidth - t) / this.text.clientWidth)
            : 2;
        if (
          (s?.forEach((t) => {
            t.remove();
          }),
          this.autoplay || e)
        )
          for (let t = 0; t <= i; t++) {
            const t = this.text.cloneNode(!0);
            t.setAttribute(xn, ""), this.scale.appendChild(t);
          }
        const o = ((this.text.clientWidth / Bn) * Number(this.speed)).toFixed(
          2
        );
        this.scale.style.removeProperty("--animation-time"),
          this.scale.style.setProperty("--animation-time", `${o}s`),
          this.scale.querySelectorAll(qn)?.forEach((t) => {
            t.classList.add(In);
          });
      } else {
        this.text.classList.add(In);
        this.scale.querySelectorAll(`[${xn}]`).forEach((t) => {
          t.parentNode.removeChild(t);
        }),
          this.text.classList.remove(In);
      }
    }
  }
  const Fn = {
      marquee: ".announcement__bar-holder--marquee",
      slide: "[data-slide]",
      slider: "[data-slider]",
      ticker: "ticker-bar",
      tickerSlide: ".announcement__slide",
    },
    $n = "hidden";
  class Nn extends HTMLElement {
    constructor() {
      super(),
        (this.slider = this.querySelector(Fn.slider)),
        (this.enableSlider = v()),
        (this.slidesCount = this.querySelectorAll(Fn.tickerSlide).length),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
    connectedCallback() {
      this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        this.addEventListener("theme:countdown:hide", (t) => {
          if (window.Shopify.designMode) return;
          const e = t.target.closest(Fn.marquee);
          if (1 === this.slidesCount) {
            this.querySelector(Fn.ticker).style.display = "none";
          }
          if (e) {
            const e = t.target.closest(Fn.tickerSlide);
            this.removeTickerText(e);
          } else {
            const e = t.target.closest(Fn.slide);
            this.removeSlide(e);
          }
        }),
        this.addEventListener("theme:countdown:expire", () => {
          this.querySelectorAll(Fn.ticker)?.forEach((t) => {
            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          this.querySelectorAll(Fn.tickerBar)?.forEach((t) => {
            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
          });
        });
    }
    initSlider() {
      const t = v(),
        e = !t;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (this.slider.flkty?.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new sn(this, this.querySelector(Fn.slider))),
        this.slider.flkty?.reposition());
    }
    removeSlide(t) {
      this.slider.flkty?.remove(t),
        0 === this.slider.flkty?.cells.length && this.section.classList.add($n);
    }
    removeTickerText(t) {
      const e = t.closest(Fn.ticker);
      t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
  }
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", Nn),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", _n);
  const Wn = "body",
    Rn = "[data-drawer]",
    zn = "[data-drawer-inner]",
    Un = "[data-drawer-underlay]",
    Vn = "[data-stagger-animation]",
    jn = "[data-header-wrapper]",
    Xn = "data-drawer-toggle",
    Jn = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Yn = "drawer--animated",
    Qn = "is-open",
    Gn = "is-closing",
    Kn = "is-focused";
  let Zn = {};
  class tr {
    constructor(t) {
      (this.isAnimating = !1),
        (this.drawer = t),
        (this.drawerWrapper = this.drawer.closest(Rn)),
        (this.drawerInner = this.drawer.querySelector(zn)),
        (this.underlay = this.drawer.querySelector(Un)),
        (this.wrapper = this.drawer.closest(jn)),
        (this.key = this.drawer.dataset.drawer),
        (this.btnSelector = `[${Xn}='${this.key}']`),
        (this.buttons = document.querySelectorAll(this.btnSelector)),
        (this.staggers = this.drawer.querySelectorAll(Vn)),
        (this.body = document.querySelector(Wn)),
        (this.showDrawer = this.showDrawer.bind(this)),
        (this.hideDrawer = this.hideDrawer.bind(this)),
        this.connectToggle(),
        this.connectDrawer(),
        this.closers();
    }
    connectToggle() {
      this.buttons.forEach((t) => {
        t.addEventListener("click", () => {
          this.drawer.dispatchEvent(
            new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
          );
        });
      });
    }
    connectDrawer() {
      this.drawer.addEventListener("theme:drawer:toggle", () => {
        this.drawer.classList.contains(Qn)
          ? this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:close", { bubbles: !0 })
            )
          : this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:open", { bubbles: !0 })
            );
      }),
        document.addEventListener("theme:cart-drawer:open", this.hideDrawer),
        document.addEventListener("theme:drawer:close", this.hideDrawer),
        document.addEventListener("theme:drawer:open", this.showDrawer);
    }
    closers() {
      this.wrapper.addEventListener("keyup", (t) => {
        "Escape" === t.code && this.hideDrawer();
      }),
        this.underlay.addEventListener("click", () => {
          this.hideDrawer();
        });
    }
    showDrawer() {
      this.isAnimating ||
        ((this.isAnimating = !0),
        this.buttons.forEach((t) => {
          t.setAttribute("aria-expanded", !0);
        }),
        this.drawer.classList.add(Qn, Yn),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.drawerInner &&
          this.drawerInner.querySelector(this.btnSelector) &&
          (F(),
          Ks(this.drawerInner).then(() => {
            this.drawer.querySelector(Jn).focus(),
              (this.isAnimating = !1),
              _(this.drawerInner, {
                elementToFocus: this.drawerInner.querySelector(
                  this.btnSelector
                ),
              });
          })));
    }
    hideDrawer() {
      this.drawer.classList.contains(Qn) &&
        !this.isAnimating &&
        ((this.isAnimating = !0),
        this.drawer.classList.add(Gn),
        this.drawer.classList.remove(Qn),
        F(),
        this.body.classList.contains(Kn) &&
          this.buttons.length &&
          this.buttons[0].focus(),
        this.buttons.forEach((t) => {
          t.setAttribute("aria-expanded", !1);
        }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        Ks(this.drawerInner).then(() => {
          this.drawer.classList.remove(Gn, Yn),
            (this.isAnimating = !1),
            document.dispatchEvent(
              new CustomEvent("theme:sliderule:close", { bubbles: !1 })
            );
        }));
    }
    onUnload() {
      document.removeEventListener("theme:cart-drawer:open", this.hideDrawer),
        document.removeEventListener("theme:drawer:close", this.hideDrawer),
        document.removeEventListener("theme:drawer:open", this.showDrawer);
    }
  }
  const er = {
      onLoad() {
        Zn[this.id] = [];
        this.container.querySelectorAll(Rn).forEach((t) => {
          Zn[this.id].push(new tr(t));
        });
      },
      onUnload() {
        Zn[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    sr = ".page-header",
    ir = "js__header__stuck",
    or = "has-header-sticky",
    nr = "shopify-section-group-header-group",
    rr = "data-header-sticky",
    ar = "data-scroll-locked";
  let lr = {};
  class cr {
    constructor(t) {
      (this.wrapper = t),
        (this.sticks = this.wrapper.hasAttribute(rr)),
        document.body.classList.toggle(or, this.sticks),
        this.sticks &&
          ((this.isStuck = !1),
          (this.cls = this.wrapper.classList),
          (this.headerOffset = document.querySelector(sr)?.offsetTop),
          (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
          (this.scrollEvent = (t) => this.onScroll(t)),
          this.listen(),
          this.stickOnLoad());
    }
    listen() {
      document.addEventListener("theme:scroll", this.scrollEvent),
        document.addEventListener(
          "shopify:section:load",
          this.updateHeaderOffset
        ),
        document.addEventListener(
          "shopify:section:unload",
          this.updateHeaderOffset
        );
    }
    onScroll(t) {
      t.detail.down
        ? !this.isStuck &&
          t.detail.position > this.headerOffset &&
          this.stickSimple()
        : t.detail.position <= this.headerOffset && this.unstickSimple();
    }
    updateHeaderOffset(t) {
      t.target.classList.contains(nr) &&
        setTimeout(() => {
          this.headerOffset = document.querySelector(sr)?.offsetTop;
        });
    }
    stickOnLoad() {
      window.scrollY > this.headerOffset && this.stickSimple();
    }
    stickSimple() {
      this.cls.add(ir), (this.isStuck = !0);
    }
    unstickSimple() {
      document.documentElement.hasAttribute(ar) ||
        (this.cls.remove(ir), (this.isStuck = !1));
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent),
        document.removeEventListener(
          "shopify:section:load",
          this.updateHeaderOffset
        ),
        document.removeEventListener(
          "shopify:section:unload",
          this.updateHeaderOffset
        );
    }
  }
  const hr = {
      onLoad() {
        lr = new cr(this.container);
      },
      onUnload: function () {
        "function" == typeof lr.unload && lr.unload();
      },
    },
    dr = "data-hover-disclosure-toggle",
    ur = "[data-hover-disclosure]",
    pr = "[data-top-link]",
    mr = "[data-header-wrapper]",
    gr = "[data-stagger]",
    vr = "[data-stagger-first]",
    yr = "[data-stagger-second]",
    fr = "is-visible",
    br = "meganav--visible",
    wr = "meganav--is-transitioning";
  let Sr = {},
    Er = {};
  class Lr {
    constructor(t) {
      (this.disclosure = t),
        (this.wrapper = t.closest(mr)),
        (this.key = this.disclosure.id),
        (this.trigger = document.querySelector(`[${dr}='${this.key}']`)),
        (this.link = this.trigger.querySelector(pr)),
        (this.grandparent = this.trigger.classList.contains("grandparent")),
        (this.transitionTimeout = 0),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.connectHoverToggle(),
        this.handleTablets(),
        this.staggerChildAnimations();
    }
    onBlockSelect(t) {
      this.disclosure.contains(t.target) && this.showDisclosure(t);
    }
    onBlockDeselect(t) {
      this.disclosure.contains(t.target) && this.hideDisclosure();
    }
    showDisclosure(t) {
      t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(wr),
        this.grandparent
          ? this.wrapper.classList.add(br)
          : this.wrapper.classList.remove(br),
        this.trigger.setAttribute("aria-expanded", !0),
        this.trigger.classList.add(fr),
        this.disclosure.classList.add(fr),
        this.transitionTimeout && clearTimeout(this.transitionTimeout),
        (this.transitionTimeout = setTimeout(() => {
          this.wrapper.classList.remove(wr);
        }, 200));
    }
    hideDisclosure() {
      this.disclosure.classList.remove(fr),
        this.trigger.classList.remove(fr),
        this.trigger.setAttribute("aria-expanded", !1),
        this.wrapper.classList.remove(br, wr);
    }
    staggerChildAnimations() {
      this.disclosure.querySelectorAll(gr).forEach((t, e) => {
        t.style.transitionDelay = 50 * e + 10 + "ms";
      });
      this.disclosure.querySelectorAll(vr).forEach((t, e) => {
        const s = 100 * e;
        (t.style.transitionDelay = `${s}ms`),
          t.parentElement.querySelectorAll(yr).forEach((t, e) => {
            const i = 20 * (e + 1);
            t.style.transitionDelay = `${s + i}ms`;
          });
      });
    }
    handleTablets() {
      this.trigger.addEventListener(
        "touchstart",
        function (t) {
          this.disclosure.classList.contains(fr) ||
            (t.preventDefault(), this.showDisclosure(t));
        }.bind(this),
        { passive: !0 }
      );
    }
    connectHoverToggle() {
      this.trigger.addEventListener("mouseenter", (t) =>
        this.showDisclosure(t)
      ),
        this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
        this.trigger.addEventListener("mouseleave", () =>
          this.hideDisclosure()
        ),
        this.trigger.addEventListener("focusout", (t) => {
          this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
        }),
        this.disclosure.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.hideDisclosure();
        });
    }
  }
  const kr = {
      onLoad() {
        (Sr[this.id] = []),
          (Er = this.container.querySelectorAll(ur)),
          Er.forEach((t) => {
            Sr[this.id].push(new Lr(t));
          });
      },
      onBlockSelect(t) {
        Sr[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Sr[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    Ar = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    Cr = "is-visible",
    Tr = "is-hiding",
    qr = "is-hidden",
    xr = "is-focused",
    Pr = "is-scrolling";
  let Mr = {};
  class Ir {
    constructor(t) {
      (this.sliderule = t), (this.key = this.sliderule.id);
      const e = `[${Ar.slideruleOpen}='${this.key}']`;
      (this.exitSelector = `[${Ar.slideruleClose}='${this.key}']`),
        (this.trigger = document.querySelector(e)),
        (this.exit = document.querySelectorAll(this.exitSelector)),
        (this.pane = document.querySelector(`[${Ar.sliderulePane}]`)),
        (this.children = this.sliderule.querySelectorAll(Ar.children)),
        (this.drawerContent = document.querySelector(Ar.drawerContent)),
        (this.cachedButton = null),
        (this.accessibility = N),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        (this.closeSliderule = this.closeSliderule.bind(this)),
        this.clickEvents(),
        this.keyboardEvents(),
        document.addEventListener("theme:sliderule:close", this.closeSliderule);
    }
    clickEvents() {
      this.trigger.addEventListener("click", () => {
        (this.cachedButton = this.trigger), this.showSliderule();
      }),
        this.exit.forEach((t) => {
          t.addEventListener("click", () => {
            this.hideSliderule();
          });
        });
    }
    keyboardEvents() {
      this.sliderule.addEventListener("keyup", (t) => {
        t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
      });
    }
    trapFocusSliderule(t = !0) {
      const e = t
        ? this.sliderule.querySelector(this.exitSelector)
        : this.cachedButton;
      this.accessibility.removeTrapFocus(),
        e &&
          this.drawerContent &&
          this.accessibility.trapFocus(this.drawerContent, {
            elementToFocus: document.body.classList.contains(xr) ? e : null,
          });
    }
    hideSliderule(t = !1) {
      const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute(Ar.sliderulePane, e),
        this.pane.classList.add(Tr),
        this.sliderule.classList.add(Tr);
      const s = t
          ? `[${Ar.dataAnimates}].${qr}`
          : `[${Ar.dataAnimates}="${e}"]`,
        i = this.pane.querySelectorAll(s);
      i.length &&
        i.forEach((t) => {
          t.classList.remove(qr);
        });
      const o = t
        ? this.pane.querySelectorAll(`.${Cr}, .${Tr}`)
        : this.children;
      o.forEach((s, i) => {
        const n = o.length - 1 == i;
        s.classList.remove(Cr),
          t && (s.classList.remove(Tr), this.pane.classList.remove(Tr));
        const r = () => {
          parseInt(this.pane.getAttribute(Ar.sliderulePane)) === e &&
            this.sliderule.classList.remove(Cr),
            this.sliderule.classList.remove(Tr),
            this.pane.classList.remove(Tr),
            n &&
              (this.accessibility.removeTrapFocus(),
              t || this.trapFocusSliderule(!1)),
            s.removeEventListener("animationend", r);
        };
        window.theme.settings.enableAnimations
          ? s.addEventListener("animationend", r)
          : r();
      });
    }
    showSliderule() {
      let t = null;
      const e = this.sliderule.closest(`.${Cr}`);
      let s = this.pane;
      e && (s = e),
        s.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
        s.classList.add(Pr);
      const i = () => {
        s.scrollTop <= 0
          ? (s.classList.remove(Pr), t && cancelAnimationFrame(t))
          : (t = requestAnimationFrame(i));
      };
      (t = requestAnimationFrame(i)), this.sliderule.classList.add(Cr);
      const o = parseInt(this.pane.dataset.sliderulePane, 10),
        n = o + 1;
      this.pane.setAttribute(Ar.sliderulePane, n);
      const r = this.pane.querySelectorAll(`[${Ar.dataAnimates}="${o}"]`);
      r.length &&
        r.forEach((t, e) => {
          const s = r.length - 1 == e;
          t.classList.add(Tr);
          const i = () => {
            t.classList.remove(Tr),
              parseInt(this.pane.getAttribute(Ar.sliderulePane)) !== o &&
                t.classList.add(qr),
              s && this.trapFocusSliderule(),
              t.removeEventListener("animationend", i);
          };
          window.theme.settings.enableAnimations
            ? t.addEventListener("animationend", i)
            : i();
        });
    }
    closeSliderule() {
      this.pane &&
        this.pane.hasAttribute(Ar.sliderulePane) &&
        parseInt(this.pane.getAttribute(Ar.sliderulePane)) > 0 &&
        (this.hideSliderule(!0),
        parseInt(this.pane.getAttribute(Ar.sliderulePane)) > 0 &&
          this.pane.setAttribute(Ar.sliderulePane, 0));
    }
    onUnload() {
      document.removeEventListener(
        "theme:sliderule:close",
        this.closeSliderule
      );
    }
  }
  const Hr = {
      onLoad() {
        Mr[this.id] = [];
        this.container.querySelectorAll(Ar.slideruleWrappper).forEach((t) => {
          Mr[this.id].push(new Ir(t));
        });
      },
      onUnload() {
        Mr[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Or = "[data-takes-space-wrapper]",
    Dr = "[data-child-takes-space]",
    Br = "[data-header-desktop]",
    _r = '.navlink[href="#"]',
    Fr = "cart-drawer",
    $r = "[data-cart-toggle]",
    Nr =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    Wr = "js__header__clone",
    Rr = "has-first-section-overlay-header",
    zr = "js__show__mobile",
    Ur = "has-header-transparent",
    Vr = "data-header-transparent";
  let jr = {};
  class Xr {
    constructor(t) {
      (this.wrapper = t),
        (this.style = this.wrapper.dataset.style),
        (this.desktop = this.wrapper.querySelector(Br)),
        (this.deadLinks = document.querySelectorAll(_r)),
        (this.resizeObserver = null),
        (this.checkWidth = this.checkWidth.bind(this)),
        this.killDeadLinks(),
        "drawer" !== this.style &&
          this.desktop &&
          ((this.minWidth = this.getMinWidth()), this.listenWidth()),
        this.cartToggleEvent();
      const e = document.querySelector(Nr);
      document.body.classList.toggle(Ur, this.wrapper.hasAttribute(Vr)),
        document.body.classList.toggle(Rr, e);
    }
    initTicker(t = !1) {
      this.tickerFrames.forEach((e) => {
        new _n(e, t);
      }),
        (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
        document.addEventListener("theme:resize:width", this.tickerResizeEvent);
    }
    listenWidth() {
      "ResizeObserver" in window
        ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
          this.resizeObserver.observe(this.wrapper))
        : document.addEventListener("theme:resize", this.checkWidth);
    }
    killDeadLinks() {
      this.deadLinks.forEach((t) => {
        t.onclick = (t) => {
          t.preventDefault();
        };
      });
    }
    checkWidth() {
      if (document.body.clientWidth < this.minWidth) {
        this.wrapper.classList.add(zr);
        const { headerHeight: t } = a();
        document.documentElement.style.setProperty("--header-height", `${t}px`);
      } else this.wrapper.classList.remove(zr);
    }
    getMinWidth() {
      const t = this.wrapper.cloneNode(!0);
      t.classList.add(Wr), document.body.appendChild(t);
      const e = t.querySelectorAll(Or);
      let s = 0,
        i = 0;
      return (
        e.forEach((t) => {
          const e = t.querySelectorAll(Dr);
          let o = 0;
          (o =
            3 === e.length
              ? (function (t) {
                  let e = [];
                  t.forEach((t) => {
                    t.firstElementChild &&
                      e.push(t.firstElementChild.clientWidth);
                  }),
                    e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]);
                  return e.reduce((t, e) => t + e);
                })(e)
              : (function (t) {
                  let e = 0;
                  return (
                    t.forEach((t) => {
                      e += t.clientWidth;
                    }),
                    e
                  );
                })(e)),
            o > s && ((s = o), (i = 20 * e.length));
        }),
        document.body.removeChild(t),
        s + i
      );
    }
    cartToggleEvent() {
      "drawer" === theme.settings.cartType &&
        this.wrapper.querySelectorAll($r)?.forEach((t) => {
          t.addEventListener("click", (e) => {
            const s = document.querySelector(Fr);
            s &&
              (e.preventDefault(),
              s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
              (window.accessibility.lastElement = t));
          });
        });
    }
    toggleButtonClick(t) {
      t.preventDefault(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:toggle", { bubbles: !0 })
        );
    }
    unload() {
      "ResizeObserver" in window
        ? this.resizeObserver?.unobserve(this.wrapper)
        : document.removeEventListener("theme:resize", this.checkWidth);
    }
  }
  yo("header", [
    {
      onLoad() {
        jr = new Xr(this.container);
      },
      onUnload() {
        "function" == typeof jr.unload && jr.unload();
      },
    },
    er,
    Hr,
    hr,
    kr,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", _n);
  const Jr = "[data-block-scroll]",
    Yr = "flickity-enabled",
    Qr = {};
  class Gr {
    constructor(t) {
      this.container = t.container;
    }
    onBlockSelect(t) {
      const e = this.container.querySelector(Jr);
      if (e && !e.classList.contains(Yr)) {
        const s = t.srcElement;
        s && e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
      }
    }
  }
  const Kr = {
      onLoad() {
        Qr[this.id] = new Gr(this);
      },
      onBlockSelect(t) {
        Qr[this.id].onBlockSelect(t);
      },
    },
    Zr = "[data-slider-mobile]",
    ta = "[data-slide]",
    ea = "[data-slider-thumb]",
    sa = "[data-slider-container]",
    ia = "[data-popup-container]",
    oa = "[data-popup-close]",
    na = "is-animating",
    ra = "is-open",
    aa = "data-slider-thumb",
    la = {};
  class ca {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Zr)),
        (this.slides = this.container.querySelectorAll(ta)),
        (this.thumbs = this.container.querySelectorAll(ea)),
        (this.popupContainer = this.container.querySelector(ia)),
        (this.popupClose = this.container.querySelectorAll(oa)),
        (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
        this.init();
    }
    init() {
      this.slider &&
        this.slides.length &&
        this.thumbs.length &&
        (this.popupContainer.addEventListener("transitionend", (t) => {
          t.target == this.popupContainer &&
            (this.popupContainer.classList.remove(na),
            t.target.classList.contains(ra)
              ? this.popupOpenCallback()
              : this.popupCloseCallback());
        }),
        this.popupContainer.addEventListener("transitionstart", (t) => {
          t.target == this.popupContainer &&
            this.popupContainer.classList.add(na);
        }),
        this.popupClose.forEach((t) => {
          t.addEventListener("click", () => {
            this.popupContainer.classList.remove(ra),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          });
        }),
        this.thumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i =
                t.hasAttribute(aa) && "" !== t.getAttribute(aa)
                  ? parseInt(t.getAttribute(aa))
                  : e,
              o = this.slides[i];
            if (y()) {
              const t = parseInt(
                window.getComputedStyle(this.slider).paddingLeft
              );
              this.slider.scrollTo({
                top: 0,
                left: o.offsetLeft - t,
                behavior: "auto",
              }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ),
                this.popupContainer.classList.add(na, ra);
            } else {
              let { stickyHeaderHeight: t } = a();
              const e = o.getBoundingClientRect().top,
                s = o.offsetHeight / 2,
                i = window.innerHeight,
                n = i / 2,
                r = this.container.querySelector(sa);
              let l = e + s - n + window.scrollY;
              if (r) {
                const e = r.getBoundingClientRect().top + window.scrollY,
                  s = e + r.offsetHeight;
                l < e ? (l = e - t) : l + i > s && (l = s - i);
              }
              window.scrollTo({ top: l, left: 0, behavior: "smooth" });
            }
          });
        }));
    }
    popupCloseByEvent() {
      this.popupContainer.classList.remove(ra);
    }
    popupOpenCallback() {
      document.addEventListener(
        "theme:quick-add:open",
        this.popupCloseByEvent,
        { once: !0 }
      ),
        document.addEventListener(
          "theme:product:added",
          this.popupCloseByEvent,
          { once: !0 }
        );
    }
    popupCloseCallback() {
      document.removeEventListener(
        "theme:quick-add:open",
        this.popupCloseByEvent,
        { once: !0 }
      ),
        document.removeEventListener(
          "theme:product:added",
          this.popupCloseByEvent,
          { once: !0 }
        );
    }
  }
  function ha() {
    this.entries = [];
  }
  function da(t, e) {
    ua(t);
    var s = (function (t, e) {
      ua(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      ua(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e);
      var s = t.variants.filter(function (t) {
        return e.every(function (e, s) {
          return t.options[s] === e;
        });
      });
      return s[0] || null;
    })(t, s);
  }
  function ua(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  yo("look", [
    {
      onLoad() {
        la[this.id] = new ca(this);
      },
    },
    Kr,
  ]),
    (ha.prototype.add = function (t, e, s) {
      this.entries.push({ element: t, event: e, fn: s }),
        t.addEventListener(e, s);
    }),
    (ha.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var pa = '[name="id"]',
    ma = '[name="selling_plan"]',
    ga = '[name^="options"]',
    va = '[name="quantity"]',
    ya = '[name^="properties"]';
  class fa {
    constructor(t, e, s) {
      (this.element = t),
        (this.product = this._validateProductObject(e)),
        (this.variantElement = this.element.querySelector(pa)),
        (s = s || {}),
        (this._listeners = new ha()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, s)
        ),
        (this.optionInputs = this._initInputs(ga, s.onOptionChange)),
        (this.planInputs = this._initInputs(ma, s.onPlanChange)),
        (this.quantityInputs = this._initInputs(va, s.onQuantityChange)),
        (this.propertyInputs = this._initInputs(ya, s.onPropertyChange));
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (t) {
        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    variant() {
      const t = this.options();
      return t.length ? da(this.product, t) : this.product.variants[0];
    }
    plan(t) {
      let e = { allocation: null, group: null, detail: null };
      const s = this.element.querySelector(`${ma}:checked`);
      if (!s) return null;
      const i = s.value,
        o = i && "" !== i ? i : null;
      return (
        o &&
          t &&
          (e.allocation = t.selling_plan_allocations.find(function (t) {
            return t.selling_plan_id.toString() === o.toString();
          })),
        e.allocation &&
          (e.group = this.product.selling_plan_groups.find(function (t) {
            return (
              t.id.toString() === e.allocation.selling_plan_group_id.toString()
            );
          })),
        e.group &&
          (e.detail = e.group.selling_plans.find(function (t) {
            return t.id.toString() === o.toString();
          })),
        e && e.allocation && e.detail && e.allocation ? e : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (t) {
        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      const t = this.variant();
      return {
        options: this.options(),
        variant: t,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(t),
      };
    }
    _setIdInputValue(t) {
      t && t.id
        ? (this.variantElement.value = t.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(t, e) {
      (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
    }
    _onOptionChange(t) {
      this._setIdInputValue(t.dataset.variant);
    }
    _onFormEvent(t) {
      return void 0 === t
        ? Function.prototype.bind()
        : function (e) {
            (e.dataset = this.getFormState()),
              this._setIdInputValue(e.dataset.variant),
              t(e);
          }.bind(this);
    }
    _initInputs(t, e) {
      return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
        function (t) {
          return this._listeners.add(t, "change", this._onFormEvent(e)), t;
        }.bind(this)
      );
    }
    _serializeInputValues(t, e) {
      return t.reduce(function (t, s) {
        return (
          (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
            t.push(e({ name: s.name, value: s.value })),
          t
        );
      }, []);
    }
    _validateProductObject(t) {
      if ("object" != typeof t) throw new TypeError(t + " is not an object.");
      if (void 0 === t.variants[0].options)
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return t;
    }
  }
  const ba = "data-scrollbar",
    wa = "data-scrollbar-slider",
    Sa = "data-scrollbar-slide-fullwidth",
    Ea = "[data-scrollbar-arrow-prev]",
    La = "[data-scrollbar-arrow-next]",
    ka = "is-hidden",
    Aa = 200;
  class Ca {
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(La)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(Ea)),
        this.scrollbar.hasAttribute(ba) && (this.init(), this.listen()),
        this.scrollbar.hasAttribute(wa) && this.scrollToVisibleElement();
    }
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(Sa)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(ka), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(Sa)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(ka), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        this.arrowNext?.classList.toggle(
          ka,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      }, Aa);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(ka, this.scrollbar.scrollLeft <= 0);
      }, Aa);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
  }
  const Ta = "[data-grid-swatch-form]",
    qa = "[data-grid-item]",
    xa = "[data-product-information]",
    Pa = "[data-product-image]",
    Ma = "[data-swatch-button]",
    Ia = "[data-swatch-link]",
    Ha = "[data-swatch-text]",
    Oa = "[data-swatch-template]",
    Da = "is-visible",
    Ba = "no-events",
    _a = "swatch",
    Fa = "data-swatch-handle",
    $a = "data-swatch-label",
    Na = "data-scrollbar",
    Wa = "data-swatch-count",
    Ra = "data-tooltip",
    za = "data-swatch-variant-name",
    Ua = "data-variant-title",
    Va = "data-swatch-values";
  class ja extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.hasAttribute(Ra) && new xo(this);
    }
  }
  class Xa extends HTMLElement {
    constructor() {
      super(),
        (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
        (this.showVariantImageEvent = (t) => this.showVariantImage(t));
    }
    connectedCallback() {
      (this.handle = this.getAttribute(Fa)),
        (this.productItem = this.closest(qa)),
        (this.productInfo = this.closest(xa)),
        (this.productImage = this.productItem.querySelector(Pa)),
        (this.template = document.querySelector(Oa).innerHTML),
        (this.swatchesJSON = this.getSwatchesJSON()),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle);
      const t = this.getAttribute($a).trim().toLowerCase();
      (function (t) {
        const e = `${window.theme.routes.root}products/${t}.js`;
        return window
          .fetch(e)
          .then((t) => t.json())
          .catch((t) => {
            console.error(t);
          });
      })(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === t || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      if (
        ((this.innerHTML = ""),
        (this.count = 0),
        (this.limitedCount = 0),
        this.swatches.forEach((t) => {
          let e = null,
            s = !1,
            i = "";
          for (const s of this.product.variants) {
            const o = s.options.includes(t);
            if ((!e && o && (e = s), o && s.featured_media)) {
              (i = s.featured_media.preview_image.src), (e = s);
              break;
            }
          }
          for (const e of this.product.variants) {
            if (e.options.includes(t) && e.available) {
              s = !0;
              break;
            }
          }
          if (e) {
            const r = document.createElement("div");
            r.innerHTML = this.template;
            const a = r.querySelector(Ma),
              l = r.querySelector(Ia),
              c = r.querySelector(Ha),
              h = this.swatchesJSON[t],
              d = "native" == theme.settings.swatchesType ? h : `var(--${h})`,
              u = e.title.replaceAll('"', "'");
            (a.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
              a.classList.add(`${_a}-${h}`),
              (a.dataset.tooltip = t),
              (a.dataset.swatchVariant = e.id),
              (a.dataset.swatchVariantName = u),
              (a.dataset.swatchImage = i),
              (a.dataset.variant = e.id),
              a.style.setProperty("--swatch", d),
              (l.href =
                ((o = this.product.url),
                (n = e.id),
                /variant=/.test(o)
                  ? o.replace(/(variant=)[^&]+/, "$1" + n)
                  : /\?/.test(o)
                  ? o.concat("&variant=").concat(n)
                  : o.concat("?variant=").concat(n))),
              (l.dataset.swatch = t),
              (l.disabled = !s),
              (c.innerText = t),
              "limited" != this.swatchesStyle
                ? (this.innerHTML += r.innerHTML)
                : this.count <= 4 &&
                  ((this.innerHTML += r.innerHTML), this.limitedCount++),
              this.count++;
          }
          var o, n;
        }),
        (this.swatchCount = this.productInfo.querySelector(`[${Wa}]`)),
        (this.swatchElements = this.querySelectorAll(Ia)),
        (this.swatchForm = this.productInfo.querySelector(Ta)),
        (this.hideSwatchesTimer = 0),
        this.swatchCount.hasAttribute(Wa))
      ) {
        if (
          "text" == this.swatchesStyle ||
          "text-slider" == this.swatchesStyle
        ) {
          if (
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            "text" == this.swatchesStyle)
          )
            return;
          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
              this.productInfo.classList.add(Ba),
              this.swatchForm.classList.add(Da);
          }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(Ba),
                  this.swatchForm.classList.remove(Da);
              }, 100);
            });
        }
        if (
          (("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) ||
            this.swatchForm.classList.add(Da),
          "limited" == this.swatchesStyle)
        ) {
          const t = this.count - this.limitedCount;
          this.swatchForm.classList.add(Da),
            t > 0 &&
              (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
        }
      }
      ("text-slider" != this.swatchesStyle && "slider" != this.swatchesStyle) ||
        (this.hasAttribute(Na) && new Ca(this)),
        this.bindSwatchButtonEvents();
    }
    bindSwatchButtonEvents() {
      this.querySelectorAll(Ma)?.forEach((t) => {
        t.addEventListener("mouseenter", this.showVariantImageEvent),
          t.hasAttribute(Ra) && new xo(t);
      }),
        this.productItem.addEventListener(
          "mouseleave",
          this.productItemMouseLeaveEvent
        );
    }
    showVariantImage(t) {
      const e = t.target,
        s = e.getAttribute(za)?.replaceAll('"', "'"),
        i = this.productImage.querySelectorAll(`[${Ua}]`),
        o = this.productImage.querySelector(`[${Ua}="${s}"]`);
      i?.forEach((t) => {
        t.classList.remove(Da);
      }),
        o?.classList.add(Da);
    }
    hideVariantImages() {
      this.productImage.querySelectorAll(`[${Ua}].${Da}`)?.forEach((t) => {
        t.classList.remove(Da);
      });
    }
    getSwatchesJSON() {
      if (!this.hasAttribute(Va)) return {};
      const t = this.getAttribute(Va).split(","),
        e = {};
      return (
        t?.forEach((t) => {
          const [s, i] = t.split(":");
          e[s.trim()] = i.trim();
        }),
        e
      );
    }
  }
  const Ja = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    Ya = "is-visible",
    Qa = "is-fade",
    Ga = "no-events",
    Ka = "is-active",
    Za = "data-sibling-cutline",
    tl = "data-sibling-image",
    el = "data-sibling-link",
    sl = "data-sibling-price",
    il = "data-product-link";
  class ol {
    constructor(t, e) {
      (this.swatches = t),
        (this.product = e),
        (this.productLinks = this.product.querySelectorAll(Ja.productLink)),
        (this.productCutline = this.product.querySelector(Ja.productCutline)),
        (this.productPrice = this.product.querySelector(Ja.productPrice)),
        (this.productImage = this.product.querySelector(Ja.productImage)),
        (this.productImageSibling = this.product.querySelector(
          Ja.productImageSibling
        )),
        this.init();
    }
    init() {
      this.cacheDefaultValues(),
        this.product.addEventListener("mouseleave", () =>
          this.resetProductValues()
        ),
        this.swatches.forEach((t) => {
          t.addEventListener("mouseenter", (t) => this.showSibling(t));
        }),
        this.productLinks.length &&
          this.swatches.forEach((t) => {
            t.addEventListener("click", () => {
              this.productLinks[0].click();
            });
          });
    }
    cacheDefaultValues() {
      (this.productLinkValue = this.productLinks[0].hasAttribute(il)
        ? this.productLinks[0].getAttribute(il)
        : ""),
        (this.productPriceValue = this.productPrice.innerHTML),
        this.productCutline &&
          (this.productCutlineValue = this.productCutline.innerHTML);
    }
    resetProductValues() {
      this.product.classList.remove(Ka),
        this.productLinkValue &&
          this.productLinks.forEach((t) => {
            t.href = this.productLinkValue;
          }),
        this.productPrice &&
          (this.productPrice.innerHTML = this.productPriceValue),
        this.productCutline &&
          this.productCutline &&
          ((this.productCutline.innerHTML = this.productCutlineValue),
          (this.productCutline.title = this.productCutlineValue)),
        this.hideSiblingImage();
    }
    showSibling(t) {
      const e = t.target,
        s = e.hasAttribute(el) ? e.getAttribute(el) : "",
        i = e.hasAttribute(sl) ? e.getAttribute(sl) : "",
        o = e.hasAttribute(Za) ? e.getAttribute(Za) : "",
        n = e.hasAttribute(tl) ? e.getAttribute(tl) : "";
      s &&
        this.productLinks.forEach((t) => {
          t.href = s;
        }),
        i && (this.productPrice.innerHTML = `<span class="price">${i}</span>`),
        this.productCutline &&
          (o
            ? ((this.productCutline.innerHTML = o),
              (this.productCutline.title = o))
            : ((this.productCutline.innerHTML = ""),
              (this.productCutline.title = ""))),
        n && this.showSiblingImage(n);
    }
    showSiblingImage(t) {
      if (!this.productImageSibling) return;
      const e = window.devicePixelRatio || 1,
        s = this.productImage.offsetWidth * e,
        i = 180 * Math.ceil(s / 180),
        n = o.getSizedImageUrl(t, `${i}x`),
        r = this.productImageSibling.querySelector(`[src="${n}"]`),
        a = () => {
          this.productImageSibling.classList.add(Ya),
            this.productImageSibling
              .querySelector(`[src="${n}"]`)
              .classList.add(Qa);
        },
        l = () => {
          this.productImageSibling.querySelectorAll("img").forEach((t) => {
            t.classList.remove(Qa);
          }),
            requestAnimationFrame(a);
        };
      if (r) l();
      else {
        const t = document.createElement("img");
        (t.src = n),
          this.productCutline && (t.alt = this.productCutline.innerText),
          t.addEventListener("load", () => {
            this.productImageSibling.append(t), l();
          });
      }
    }
    hideSiblingImage() {
      this.productImageSibling &&
        (this.productImageSibling.classList.remove(Ya),
        this.productImageSibling.querySelectorAll("img").forEach((t) => {
          t.classList.remove(Qa);
        }));
    }
  }
  class nl extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.product = this.closest(Ja.productGridItem)),
        (this.siblingScrollbar = this.querySelector(Ja.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(Ja.siblingCount)),
        (this.siblingFieldset = this.querySelector(Ja.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(Ja.siblingLink)),
        (this.productInfo = this.closest(Ja.productInfo)),
        (this.productLink = this.closest(Ja.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        this.initScrollbar(),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" != this.swatchesStyle &&
            "slider" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
            this.siblingFieldset.classList.add(Ya),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length && new ol(this.siblingLinks, this.product),
        this.querySelectorAll(Ja.tooltip).forEach((t) => {
          new xo(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(Ga),
        "text" != this.swatchesStyle && this.siblingFieldset.classList.add(Ya);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(Ga),
          this.siblingFieldset.classList.remove(Ya);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new Ca(this.siblingScrollbar);
    }
  }
  const rl = "[data-hover-slide]",
    al = "[data-hover-slide-touch]",
    ll = "[data-hover-slider]",
    cl = "[data-product-link]",
    hl = ".flickity-prev-next-button";
  class dl extends HTMLElement {
    constructor() {
      super(),
        (this.flkty = null),
        (this.slider = this.querySelector(ll)),
        (this.handleScroll = this.handleScroll.bind(this));
    }
    connectedCallback() {
      window.theme.touch ? this.initTouch() : this.initFlickity();
    }
    disconnectedCallback() {
      this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    initTouch() {
      this.style.setProperty(
        "--slides-count",
        this.querySelectorAll(al).length
      ),
        this.slider.addEventListener("scroll", this.handleScroll);
    }
    handleScroll() {
      const t = this.slider.scrollLeft / this.slider.clientWidth;
      this.style.setProperty("--slider-index", t);
    }
    initFlickity() {
      this.querySelectorAll(rl).length < 2 ||
        ((this.flkty = new s(this.slider, {
          cellSelector: rl,
          contain: !0,
          wrapAround: !0,
          watchCSS: !0,
          autoPlay: !1,
          draggable: !1,
          pageDots: !1,
          prevNextButtons: !0,
        })),
        this.flkty.pausePlayer(),
        this.addEventListener("mouseenter", () => {
          this.flkty.unpausePlayer();
        }),
        this.addEventListener("mouseleave", () => {
          this.flkty.pausePlayer();
        }),
        this.closest(cl).addEventListener("click", (t) => {
          t.target.matches(hl) && t.preventDefault();
        }));
    }
  }
  const ul = "body",
    pl = "[data-related-section]",
    ml = "[data-tabs-holder]",
    gl = "data-tab",
    vl = "data-tab-index",
    yl = "[data-aos]",
    fl = "data-block-id",
    bl = "[data-tab]",
    wl = ".tab-link",
    Sl = ".tab-link__recent",
    El = ".tab-content",
    Ll = "[data-scrollbar]",
    kl = "current",
    Al = "hidden",
    Cl = "aos-animate",
    Tl = "aos-no-transition",
    ql = "is-focused",
    xl = {};
  class Pl {
    constructor(t) {
      (this.container = t),
        (this.body = document.querySelector(ul)),
        (this.accessibility = window.accessibility),
        this.container &&
          ((this.scrollbarHolder = this.container.querySelectorAll(Ll)),
          this.init(),
          this.initNativeScrollbar());
    }
    init() {
      const t = this.container.querySelectorAll(bl);
      this.container.addEventListener("theme:tab:check", () =>
        this.checkRecentTab()
      ),
        this.container.addEventListener("theme:tab:hide", () =>
          this.hideRelatedTab()
        ),
        t.length &&
          t.forEach((t) => {
            const e = parseInt(t.getAttribute(gl)),
              s = this.container.querySelector(`${El}-${e}`);
            t.addEventListener("click", () => {
              this.tabChange(t, s);
            }),
              t.addEventListener("keyup", (e) => {
                ("Space" !== e.code && "Enter" !== e.code) ||
                  !this.body.classList.contains(ql) ||
                  this.tabChange(t, s);
              });
          });
    }
    tabChange(t, e) {
      if (t.classList.contains(kl)) return;
      const s = this.container.querySelector(`${bl}.${kl}`),
        i = this.container.querySelector(`${El}.${kl}`);
      s?.classList.remove(kl),
        i?.classList.remove(kl),
        t.classList.add(kl),
        e.classList.add(kl),
        t.classList.contains(Al) && e.classList.add(Al),
        this.accessibility.a11y.removeTrapFocus(),
        this.container.dispatchEvent(
          new CustomEvent("theme:tab:change", { bubbles: !0 })
        ),
        t.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "tab" },
          })
        ),
        this.animateItems(e);
    }
    animateItems(t, e = !0) {
      const s = t.querySelectorAll(yl);
      s.length &&
        s.forEach((t) => {
          t.classList.remove(Cl),
            e &&
              (t.classList.add(Tl),
              requestAnimationFrame(() => {
                t.classList.remove(Tl), t.classList.add(Cl);
              }));
        });
    }
    initNativeScrollbar() {
      this.scrollbarHolder.length &&
        this.scrollbarHolder.forEach((t) => {
          new Ca(t);
        });
    }
    checkRecentTab() {
      const t = this.container.querySelector(Sl);
      if (t) {
        t.classList.remove(Al);
        const e = parseInt(t.getAttribute(gl)),
          s = this.container.querySelector(`${El}[${vl}="${e}"]`);
        s && (s.classList.remove(Al), this.animateItems(s, !1)),
          this.initNativeScrollbar();
      }
    }
    hideRelatedTab() {
      const t = this.container.querySelector(pl);
      if (!t) return;
      const e = t.closest(`${El}.${kl}`);
      if (!e) return;
      const s = parseInt(e.getAttribute(vl)),
        i = this.container.querySelectorAll(bl);
      if (i.length > s) {
        const t = i[s].nextSibling;
        t &&
          (i[s].classList.add(Al),
          t.dispatchEvent(new Event("click")),
          this.initNativeScrollbar());
      }
    }
    onBlockSelect(t) {
      const e = this.container.querySelector(
        `${wl}[${fl}="${t.detail.blockId}"]`
      );
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({
          top: 0,
          left: e.offsetLeft - e.clientWidth,
          behavior: "smooth",
        }));
    }
  }
  const Ml = {
    onLoad() {
      xl[this.id] = [];
      this.container.querySelectorAll(ml).forEach((t) => {
        xl[this.id].push(new Pl(t));
      });
    },
    onBlockSelect(t) {
      xl[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  function Il() {
    const t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  const Hl = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    Ol = 3e3,
    Dl = "[data-animation]",
    Bl = "[data-api-content]",
    _l = "[data-quick-add-btn]",
    Fl = "[data-add-to-cart]",
    $l = "cart-drawer",
    Nl = "[data-cart-page]",
    Wl = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Rl = "[data-message-error]",
    zl = "[data-quick-add-modal-handle]",
    Ul = "[data-product-upsell-ajax]",
    Vl = "[data-quick-add-modal-close]",
    jl = "data-grid-item",
    Xl = "[data-product-information]",
    Jl = "[data-quick-add-holder]",
    Yl = "[data-quick-add-modal]",
    Ql = "[data-quick-add-modal-template]",
    Gl = "[data-tooltip]",
    Kl = "closing",
    Zl = "data-product-id",
    tc = "data-quick-add-modal-handle",
    ec = "data-sibling-swapper",
    sc = "data-quick-add-holder";
  class ic extends HTMLElement {
    constructor() {
      super(),
        (this.container = this),
        (this.cart = document.querySelector($l) || document.querySelector(Nl)),
        (this.quickAddHolder = this.container.querySelector(Jl)),
        this.quickAddHolder &&
          ((this.modal = null),
          (this.currentModal = null),
          (this.productId = this.quickAddHolder.getAttribute(sc)),
          (this.modalButton = this.quickAddHolder.querySelector(zl)),
          (this.handle = this.modalButton?.getAttribute(tc)),
          (this.cartDrawer = document.querySelector($l)),
          (this.buttonQuickAdd = this.quickAddHolder.querySelector(_l)),
          (this.buttonATC = this.quickAddHolder.querySelector(Fl)),
          (this.button = this.modalButton || this.buttonATC),
          (this.modalClose = this.modalClose.bind(this)),
          (this.modalCloseOnProductAdded =
            this.modalCloseOnProductAdded.bind(this)),
          (this.a11y = N),
          (this.isAnimating = !1),
          (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
          (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.cart &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.accessibility.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(ec),
        s = this.modalButton.classList.contains(Hl.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(Hl.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(Yl)),
          this.currentModal.classList.add(Hl.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${Yl}[${Zl}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(Ql);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(Yl)),
          e.remove(),
          (this.modal = document.querySelector(
            `${Yl}[${Zl}="${this.productId}"]`
          )),
          (this.modal.querySelector(Ul).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(Bl).innerHTML),
          this.modal.querySelectorAll(Gl).forEach((t) => {
            new xo(t);
          }),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(Hl.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(Hl.loading),
          (this.modalButton.disabled = !1),
          (window.accessibility.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Dl).forEach((t) => {
            t.classList.add(Hl.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Kl))
          return this.modal.setAttribute(Kl, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Kl),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(Hl.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(Hl.disabled) &&
            this.quickAddHolder.classList.remove(Hl.disabled),
          this.resetAnimatedItems(),
          Il() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      this.modal.querySelector(Vl)?.addEventListener("click", (t) => {
        t.preventDefault(), this.modalClose();
      }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Kl)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(Wl);
                  t?.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Hl.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${jl}]`);
        if (!s) return;
        const i = e.querySelector(Rl),
          o = s.classList.contains(Hl.overlayText),
          n = s.querySelector(Xl),
          r = e.querySelector(Fl);
        r &&
          (r.classList.remove(Hl.added, Hl.loading), e.classList.add(Hl.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(Hl.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(Hl.hidden);
          }, Ol);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Hl.visible, Hl.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(Hl.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), P(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new He({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      this.modal?.querySelectorAll(Dl).forEach((t) => {
        t.classList.remove(Hl.animated);
      });
    }
  }
  yo("product-grid", [Ml]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", ic),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ja),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", Xa),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", nl),
    customElements.get("hover-images") ||
      customElements.define("hover-images", dl);
  const oc = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    nc = 'input[type="email"]',
    rc = 'input[type="checkbox"]',
    ac = "[data-form-wrapper]";
  class lc extends HTMLElement {
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(rc)),
        (this.fieldEmail = this.querySelector(nc)),
        (this.fields = this.querySelectorAll(oc)),
        (this.form = this.closest(ac)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
  }
  const cc = ".product__page",
    hc = "[data-form-wrapper]",
    dc = "[data-header-sticky]",
    uc = "[data-product-media-list]",
    pc = "is-sticky",
    mc = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const gc = {};
  class vc {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.stickyEnabled = "true" === this.container.getAttribute(mc)),
        (this.formWrapper = this.container.querySelector(hc)),
        (this.stickyScrollTop = 0),
        (this.scrollLastPosition = 0),
        (this.stickyDefaultTop = 0),
        (this.currentPoint = 0),
        (this.defaultTopBottomSpacings = 30),
        (this.scrollTop = window.scrollY),
        (this.scrollDirectionDown = !0),
        (this.requestAnimationSticky = null),
        (this.stickyFormLoad = !0),
        (this.stickyFormLastHeight = null),
        (this.onChangeCounter = 0),
        (this.scrollEvent = (t) => this.scrollEvents(t)),
        (this.resizeEvent = (t) => this.resizeEvents(t)),
        (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
        setTimeout(() => {
          this.init();
        }, 50);
    }
    init() {
      this.stickyEnabled &&
        (this.stickyScrollCheck(),
        document.addEventListener("theme:resize", this.resizeEvent)),
        this.initSticky();
    }
    initSticky() {
      theme.variables.productPageSticky &&
        ((this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition()
        )),
        this.formWrapper.addEventListener(
          "theme:form:sticky",
          this.stickyFormEvent
        ),
        document.addEventListener("theme:scroll", this.scrollEvent));
    }
    stickyFormEvents(t) {
      this.removeAnimationFrameSticky(),
        (this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition(t)
        ));
    }
    scrollEvents(t) {
      (this.scrollTop = t.detail.position),
        (this.scrollDirectionDown = t.detail.down),
        this.requestAnimationSticky ||
          (this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          ));
    }
    resizeEvents(t) {
      this.stickyScrollCheck(),
        document.removeEventListener("theme:scroll", this.scrollEvent),
        this.formWrapper.removeEventListener(
          "theme:form:sticky",
          this.stickyFormEvent
        ),
        this.initSticky();
    }
    stickyScrollCheck() {
      const t = this.container.querySelector(`${cc} ${hc}`);
      if (t)
        if (v()) {
          const e = this.container.querySelector(hc),
            s = this.container.querySelector(uc);
          if (!e || !s) return;
          e.offsetHeight < s.offsetHeight
            ? ((theme.variables.productPageSticky = !0), t.classList.add(pc))
            : ((theme.variables.productPageSticky = !1),
              t.classList.remove(pc));
        } else (theme.variables.productPageSticky = !1), t.classList.remove(pc);
    }
    calculateStickyPosition(t = null) {
      if (document.documentElement.hasAttribute("data-scroll-locked"))
        return void this.removeAnimationFrameSticky();
      const e = Boolean(t && t.detail),
        s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
        i = this.formWrapper.offsetHeight,
        o = window.innerHeight - i - this.defaultTopBottomSpacings,
        n = Math.abs(this.scrollTop - this.scrollLastPosition);
      if (
        (this.scrollDirectionDown
          ? (this.stickyScrollTop -= n)
          : (this.stickyScrollTop += n),
        this.stickyFormLoad)
      ) {
        if (document.querySelector(dc)) {
          let { headerHeight: t } = a();
          this.stickyDefaultTop = t;
        } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
        this.stickyScrollTop = this.stickyDefaultTop;
      }
      this.stickyScrollTop = Math.min(
        Math.max(this.stickyScrollTop, o),
        this.stickyDefaultTop
      );
      const r = this.stickyScrollTop - this.currentPoint;
      (this.currentPoint = this.stickyFormLoad
        ? this.stickyScrollTop
        : this.currentPoint + 0.5 * r),
        this.formWrapper.style.setProperty(
          "--sticky-top",
          `${this.currentPoint}px`
        ),
        (this.scrollLastPosition = this.scrollTop),
        (this.stickyFormLoad = !1),
        (s && this.onChangeCounter <= 10) ||
        (s && this.stickyFormLastHeight !== i) ||
        (this.stickyScrollTop !== this.currentPoint &&
          this.requestAnimationSticky)
          ? (s && (this.onChangeCounter += 1),
            s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(t)
            )))
          : this.requestAnimationSticky && this.removeAnimationFrameSticky(),
        (this.stickyFormLastHeight = i);
    }
    removeAnimationFrameSticky() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null),
        (this.onChangeCounter = 0));
    }
    onUnload() {
      this.stickyEnabled &&
        document.removeEventListener("theme:resize", this.resizeEvent),
        theme.variables.productPageSticky &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
  }
  const yc = {
      onLoad() {
        gc[this.id] = new vc(this);
      },
      onUnload() {
        gc[this.id].onUnload();
      },
    },
    fc = "[data-button-arrow]",
    bc = "[data-deferred-media-button]",
    wc = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    Sc = "[data-image-id]",
    Ec = "[data-product-media-list]",
    Lc = "[data-section-type]",
    kc = "slider__arrows",
    Ac = "is-dragging",
    Cc = "is-focused",
    Tc = "media--active",
    qc = "media--hidden",
    xc = "media--hiding",
    Pc = "data-active-media",
    Mc = "data-button-prev",
    Ic = "data-button-next",
    Hc = "data-image-id",
    Oc = "data-media-id",
    Dc = "data-fader-desktop",
    Bc = "data-fader-mobile";
  class _c extends HTMLElement {
    constructor() {
      super(),
        (this.initialized = !1),
        (this.buttons = !1),
        (this.isDown = !1),
        (this.startX = 0),
        (this.startY = 0),
        (this.scrollLeft = 0),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.container = this.closest(Lc)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleKeyUp = this.handleKeyUp.bind(this)),
        (this.productMediaItems = this.querySelectorAll(Sc)),
        (this.productMediaList = this.querySelector(Ec)),
        (this.setHeight = this.setHeight.bind(this)),
        (this.toggleEvents = this.toggleEvents.bind(this)),
        (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
    }
    connectedCallback() {
      1 !== Object.keys(this.productMediaItems).length &&
        (this.productMediaObserver(),
        this.toggleEvents(),
        this.listen(),
        this.setHeight());
    }
    disconnectedCallback() {
      this.unlisten();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.toggleEvents),
        document.addEventListener("theme:resize:width", this.setHeight),
        this.addEventListener("theme:media:select", this.selectMediaEvent);
    }
    unlisten() {
      document.removeEventListener("theme:resize:width", this.toggleEvents),
        document.removeEventListener("theme:resize:width", this.setHeight),
        this.removeEventListener("theme:media:select", this.selectMediaEvent);
    }
    toggleEvents() {
      const t = y();
      (t && this.hasAttribute(Bc)) || (!t && this.hasAttribute(Dc))
        ? this.bindEventListeners()
        : this.unbindEventListeners();
    }
    bindEventListeners() {
      this.initialized ||
        (this.productMediaList.addEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
        this.productMediaList.addEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.addEventListener(
          "touchstart",
          this.handleMouseDown,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
          passive: !0,
        }),
        this.productMediaList.addEventListener(
          "touchmove",
          this.handleMouseMove,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("keyup", this.handleKeyUp),
        this.initArrows(),
        this.resetScrollPosition(),
        (this.initialized = !0));
    }
    unbindEventListeners() {
      this.initialized &&
        (this.productMediaList.removeEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.removeEventListener(
          "mouseup",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener(
          "touchstart",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "touchend",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "touchmove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
        this.removeArrows(),
        (this.initialized = !1));
    }
    handleMouseDown(t) {
      (this.isDown = !0),
        (this.startX =
          (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
        (this.startY =
          (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
    }
    handleMouseLeave() {
      this.isDown && (this.isDown = !1);
    }
    handleMouseUp(t) {
      const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
        s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
        i = e - this.startX,
        o = s - this.startY,
        n = i > 0 ? 1 : -1;
      Math.abs(i) > 10 &&
        Math.abs(i) > Math.abs(o) &&
        (n < 0 ? this.showNextImage() : this.showPreviousImage()),
        (this.isDown = !1),
        requestAnimationFrame(() => {
          this.classList.remove(Ac);
        });
    }
    handleMouseMove() {
      this.isDown && this.classList.add(Ac);
    }
    handleKeyUp(t) {
      "ArrowLeft" === t.code && this.showPreviousImage(),
        "ArrowRight" === t.code && this.showNextImage();
    }
    handleArrowsClickEvent() {
      this.querySelectorAll(fc)?.forEach((t) => {
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            t.target.hasAttribute(Mc) && this.showPreviousImage(),
            t.target.hasAttribute(Ic) && this.showNextImage();
        });
      });
    }
    resetScrollPosition() {
      0 !== this.productMediaList.scrollLeft &&
        (this.productMediaList.scrollLeft = 0);
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(kc),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.productMediaList.append(t),
          (this.buttons = this.querySelectorAll(fc)),
          (this.buttonPrev = this.querySelector(`[${Mc}]`)),
          (this.buttonNext = this.querySelector(`[${Ic}]`));
      }
      this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
    }
    removeArrows() {
      this.querySelector(`.${kc}`)?.remove();
    }
    preloadImageOnArrowHover() {
      this.buttonPrev?.addEventListener("mouseover", () => {
        const t = this.getPreviousMediaId();
        this.preloadImage(t);
      }),
        this.buttonNext?.addEventListener("mouseover", () => {
          const t = this.getNextMediaId();
          this.preloadImage(t);
        });
    }
    preloadImage(t) {
      this.querySelector(`[${Oc}="${t}"] img`)?.setAttribute(
        "loading",
        "eager"
      );
    }
    showMediaOnVariantSelect(t) {
      const e = t.detail.id;
      this.setActiveMedia(e);
    }
    getCurrentMedia() {
      return this.querySelector(`${Sc}.${Tc}`);
    }
    getNextMediaId() {
      const t = this.getCurrentMedia(),
        e = t?.nextElementSibling.hasAttribute(Hc)
          ? t?.nextElementSibling
          : this.querySelector(Sc);
      return e?.getAttribute(Oc);
    }
    getPreviousMediaId() {
      const t = this.getCurrentMedia(),
        e = this.productMediaItems.length - 1,
        s = t?.previousElementSibling || this.productMediaItems[e];
      return s?.getAttribute(Oc);
    }
    showNextImage() {
      const t = this.getNextMediaId();
      this.selectMedia(t);
    }
    showPreviousImage() {
      const t = this.getPreviousMediaId();
      this.selectMedia(t);
    }
    selectMedia(t) {
      this.dispatchEvent(
        new CustomEvent("theme:media:select", { detail: { id: t } })
      );
    }
    setActiveMedia(t) {
      if (!t) return;
      this.setAttribute(Pc, t);
      const e = this.querySelector(`${Sc}.${Tc}`),
        s = this.querySelector(`[${Oc}="${t}"]`),
        i = s?.querySelector(wc),
        o = s.querySelector("deferred-media");
      e?.classList.add(xc),
        e?.classList.remove(Tc),
        s?.classList.remove(xc, qc),
        s?.classList.add(Tc),
        o &&
          !0 !== o.getAttribute("loaded") &&
          s
            .querySelector(bc)
            ?.dispatchEvent(new Event("click", { bubbles: !1 })),
        requestAnimationFrame(() => {
          this.setHeight(), document.body.classList.contains(Cc) && i?.focus();
        });
    }
    setHeight() {
      const t =
        this.querySelector(`${Sc}.${Tc}`)?.offsetHeight ||
        this.productMediaItems[0]?.offsetHeight;
      this.style.setProperty("--height", `${t}px`);
    }
    productMediaObserver() {
      this.productMediaItems.forEach((t) => {
        t.addEventListener("transitionend", (e) => {
          e.target == t &&
            t.classList.contains(xc) &&
            (t.classList.remove(xc), t.classList.add(qc));
        }),
          t.addEventListener("transitioncancel", (e) => {
            e.target == t &&
              t.classList.contains(xc) &&
              (t.classList.remove(xc), t.classList.add(qc));
          });
      });
    }
  }
  const Fc = "data-option-position",
    $c = '[name^="options"], [data-popout-option]',
    Nc = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    Wc = "data-value",
    Rc = "[data-popout]",
    zc = "sold-out",
    Uc = "unavailable",
    Vc = "sale";
  class jc {
    constructor(t, e) {
      (this.container = t),
        (this.productJSON = e),
        (this.optionElements = this.container.querySelectorAll($c)),
        this.productJSON && this.optionElements.length && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((t) => {
          const e = t.closest(`[${Fc}]`);
          if (!e) return;
          const s = t.value || t.getAttribute(Wc),
            i = e.getAttribute(Fc),
            o = parseInt(i, 10) - 1,
            n = t.closest(Rc);
          let r = [...this.selections];
          r[o] = s;
          const a = this.productJSON.variants.find((t) => {
            let e = !0;
            for (let s = 0; s < r.length; s++)
              t.options[s] !== r[s] && (e = !1);
            return e;
          });
          t.classList.remove(zc, Uc),
            t.parentNode.classList.remove(Vc),
            t.closest(".radio__button").classList.remove(Uc),
            n && n.classList.remove(zc, Uc, Vc),
            void 0 === a
              ? (t.classList.add(Uc),
                n && n.classList.add(Uc),
                t.closest(".radio__button").classList.add(Uc))
              : a &&
                !1 === a.available &&
                (t.classList.add(zc), n && n.classList.add(zc)),
            a &&
              a.compare_at_price > a.price &&
              theme.settings.variantOnSale &&
              t.parentNode.classList.add(Vc);
        });
    }
    getCurrentState() {
      this.selections = [];
      const t = this.container.querySelectorAll(Nc);
      t.length &&
        t.forEach((t) => {
          const e = t.value;
          e && "" !== e && this.selections.push(e);
        });
    }
  }
  const Xc = "[data-product]",
    Jc = "[data-product-form]",
    Yc = "product-notification",
    Qc = "[data-variant-title]",
    Gc = "[data-notification-product]",
    Kc = "[data-add-to-cart]",
    Zc = "[data-add-to-cart-text]",
    th = "cart-drawer",
    eh = "[data-cart-page]",
    sh = "[data-compare-price]",
    ih = "[data-compare-text]",
    oh = "[data-form-wrapper]",
    nh = "[data-product-select]",
    rh = "[data-price-wrapper]",
    ah = "product-images",
    lh = "[data-product-media-list]",
    ch = "[data-product-json]",
    hh = "[data-product-price]",
    dh = "[data-product-unit-price]",
    uh = "[data-product-base]",
    ph = "[data-product-unit]",
    mh = "[data-product-preorder]",
    gh = "[data-subscription-watch-price]",
    vh = "[data-subscription-selectors]",
    yh = "[data-toggles-group]",
    fh = "data-group-toggle",
    bh = "[data-plan-description]",
    wh = "[data-section-type]",
    Sh = "[data-variant-sku]",
    Eh = "[data-variant-final-sale-metafield]",
    Lh = "[data-variant-buttons]",
    kh = "[data-variant-option-image]",
    Ah = "[data-quick-add-modal]",
    Ch = "[data-price-off]",
    Th = "[data-price-off-type]",
    qh = "[data-price-off-amount]",
    xh = "[data-remaining-count]",
    Ph = "[data-remaining-max]",
    Mh = "[data-remaining-wrapper]",
    Ih = "[data-product-remaining-json]",
    Hh = "[data-option-value]",
    Oh = "[data-option-position]",
    Dh = "[data-product-form-installment]",
    Bh = 'input[name="id"]',
    _h = "hidden",
    Fh = "variant--soldout",
    $h = "variant--unavailable",
    Nh = "product__price--sale",
    Wh = "count-is-low",
    Rh = "count-is-in",
    zh = "count-is-out",
    Uh = "count-is-unavailable",
    Vh = "data-remaining-max",
    jh = "data-enable-history-state",
    Xh = "data-fader-desktop",
    Jh = "data-fader-mobile",
    Yh = "data-option-position",
    Qh = "data-image-id",
    Gh = "data-media-id",
    Kh = "data-quick-add-btn",
    Zh = "data-final-sale",
    td = "data-variant-image-scroll";
  class ed extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(wh) || this.closest(Ah)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(Xc)),
        (this.productForm = this.container.querySelector(Jc)),
        (this.productNotification = this.container.querySelector(Yc)),
        (this.productImages = this.container.querySelector(ah)),
        (this.productMediaList = this.container.querySelector(lh)),
        (this.installmentForm = this.container.querySelector(Dh)),
        (this.skuWrapper = this.container.querySelector(Sh)),
        (this.sellout = null),
        (this.variantImageScroll = "true" === this.container.getAttribute(td)),
        (this.priceOffWrap = this.container.querySelector(Ch)),
        (this.priceOffAmount = this.container.querySelector(qh)),
        (this.priceOffType = this.container.querySelector(Th)),
        (this.planDescription = this.container.querySelector(bh)),
        (this.remainingWrapper = this.container.querySelector(Mh)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(Ph);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(Vh), 10)),
          (this.remainingCount = this.container.querySelector(xh)),
          (this.remainingJSONWrapper = this.container.querySelector(Ih)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(jh)),
        (this.hasUnitPricing = this.container.querySelector(ph)),
        (this.subSelectors = this.container.querySelector(vh)),
        (this.subPrices = this.container.querySelector(gh)),
        (this.isPreOrder = this.container.querySelector(mh));
      let t = null;
      const e = this.container.querySelector(ch);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new jc(this.container, this.productJSON)))
          : console.error("Missing product JSON"),
        (this.variantOptionImages = this.container.querySelectorAll(kh)),
        (this.variantButtons = this.container.querySelectorAll(Lh)),
        this.variantOptionImages.length > 1 && this.optionImagesWidth();
    }
    cartAddEvents() {
      this.buttonATC = this.querySelector(Kc);
      const t = document.querySelector(th) || document.querySelector(eh);
      this.buttonATC &&
        t &&
        this.buttonATC.addEventListener("click", (t) => {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                detail: { button: this.buttonATC },
                bubbles: !1,
              })
            ),
            this.closest(Ah) ||
              (window.accessibility.lastElement = this.buttonATC);
        });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new fa(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateNotificationForm(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSku(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        this.sellout?.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(rh),
        o = this.container.querySelectorAll(Kc),
        n = this.container.querySelectorAll(Zc),
        r = this.container.querySelectorAll(oh);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(Bh);
        (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(_h);
          }),
        o?.forEach((t) => {
          t.hasAttribute(Kh) ||
            (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
        }),
        n?.forEach((t) => {
          let i = s;
          e
            ? e.available || (i = theme.strings.soldOut)
            : (i = theme.strings.unavailable),
            (t.textContent = i);
        }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(Fh, $h)
                : (t.classList.add(Fh), t.classList.remove($h));
              const s = t.querySelector(nh);
              s && (s.value = e.id);
              const i = t.querySelector(`${Bh}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add($h), t.classList.remove(Fh);
          });
    }
    updateNotificationForm(t) {
      if (!this.productNotification) return;
      const e = this.productNotification.querySelector(Qc),
        s = this.productNotification.querySelector(Gc);
      null != e &&
        ((e.textContent = t.variant?.title), (s.value = t.variant?.name));
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(t) {
      const e = t.variant;
      if (
        (this.remainingWrapper?.classList.remove(Rh, zh, Uh, Wh),
        e && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[e.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(zh),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(Rh),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(Wh),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !e && this.remainingWrapper && this.remainingWrapper.classList.add(Uh);
    }
    optionImagesWidth() {
      if (!this.variantButtons) return;
      let t = 0;
      for (const e of this.variantOptionImages) {
        const s = e.offsetWidth;
        s > t && (t = s);
      }
      this.variantButtons.style?.setProperty("--option-image-width", t + "px");
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(yh).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${fh}="${e}"]`),
              i = this.container.querySelectorAll(`[${fh}]`);
            if (s) {
              s.classList.remove(_h);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(_h);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(_h);
    }
    isVariantFinalSale(t) {
      const e = document.querySelector(Eh).textContent,
        s = JSON.parse(e);
      let i = !1;
      return (
        s.forEach((e) => {
          Number(e.variant_id) === t.id && (i = "true" === e.metafield_value);
        }),
        i
      );
    }
    updateSaleTextStandard(t) {
      const e = t.variant;
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = (e.compare_at_price - e.price) / e.compare_at_price,
          s = Math.floor(100 * t);
        (this.priceOffAmount.innerHTML = `${s}%`),
          this.priceOffWrap.classList.remove(_h);
      }
      if (this.priceOffWrap) {
        this.priceOffWrap.hasAttribute(Zh) || this.isVariantFinalSale(e)
          ? this.priceOffWrap.classList.remove(_h)
          : this.priceOffWrap.classList.add(_h);
      }
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(_h))
        : this.planDescription && this.planDescription.classList.add(_h);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          s = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${s}%`)
          : (this.priceOffAmount.innerHTML = Me(s, theme.moneyFormat)),
          this.priceOffWrap.classList.remove(_h);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        s = t.plan;
      this.container.querySelectorAll(rh).forEach((t) => {
        const i = t.querySelector(sh),
          o = t.querySelector(hh),
          n = t.querySelector(ih);
        let r = "",
          a = "";
        this.productState.available &&
          ((r = e.compare_at_price), (a = e.price)),
          this.productState.hasPlan && (a = s.allocation.price),
          this.productState.planSale &&
            ((r = s.allocation.compare_at_price), (a = s.allocation.price)),
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(_h),
                n.classList.remove(_h),
                o.classList.add(Nh))
              : (i.classList.add(_h),
                n.classList.add(_h),
                o.classList.remove(Nh)),
            (i.innerHTML = Me(r, theme.moneyFormat))),
          (o.innerHTML =
            0 === a ? window.theme.strings.free : Me(a, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        s = t.plan;
      let i = null;
      if (
        (e && e.unit_price && (i = e.unit_price),
        s &&
          s.allocation &&
          s.allocation.unit_price &&
          (i = s.allocation.unit_price),
        i)
      ) {
        const t = this.getBaseUnit(e),
          s = Me(i, theme.moneyFormat);
        (this.container.querySelector(dh).innerHTML = s),
          (this.container.querySelector(uh).innerHTML = t),
          Te(this.container.querySelector(ph));
      } else
        (o = this.container.querySelector(ph)) && (o.style.display = "none");
      var o;
    }
    updateSku(t) {
      this.skuWrapper &&
        (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `[${Qh}="${e.featured_media.id}"]`
        );
        if (t) {
          const e = t.getAttribute(Gh),
            s = v();
          if (
            (t.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: e },
              })
            ),
            s &&
              !this.productImages.hasAttribute(Xh) &&
              this.variantImageScroll)
          ) {
            const e = t.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              nn(e);
          }
          s ||
            this.productImages.hasAttribute(Jh) ||
            this.productMediaList.scrollTo({ left: t.offsetLeft });
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(Hh);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(Oh);
            if (s) {
              const i = s.getAttribute(Yh),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
  }
  const sd = "[data-popup-open]",
    id = "[data-popup-close]",
    od = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    nd = "closing";
  class rd {
    constructor(t, e, s = !0, i = !0) {
      (this.popup = t),
        (this.holder = e),
        (this.a11y = N),
        (this.isAnimating = !1),
        (this.showModal = s),
        (this.enableScrollLock = i),
        (this.buttonPopupOpen = this.holder?.querySelector(sd)),
        this.popupEvents();
    }
    popupOpen() {
      this.popup &&
        ((this.isAnimating = !0),
        this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal || "function" != typeof this.popup.show
          ? this.popup.setAttribute("open", "")
          : this.popup.show(),
        this.popup.removeAttribute("inert"),
        this.popup.focus(),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        Ks(this.popup).then(() => {
          (this.isAnimating = !1),
            this.enableScrollLock && this.a11y.trapFocus(this.popup);
          const t =
            this.popup.querySelector("[autofocus]") ||
            this.popup.querySelector(od);
          t?.focus();
        }));
    }
    popupClose() {
      if (
        !this.isAnimating &&
        this.popup &&
        !this.popup.hasAttribute("inert")
      ) {
        if (!this.popup.hasAttribute(nd))
          return (
            this.popup.setAttribute(nd, ""),
            (this.isAnimating = !0),
            void Ks(this.popup).then(() => {
              (this.isAnimating = !1), this.popupClose();
            })
          );
        "function" == typeof this.popup.close
          ? this.popup.close()
          : this.popup.removeAttribute("open"),
          this.popupCloseActions();
      }
    }
    popupCloseActions() {
      this.popup.hasAttribute("inert") ||
        (this.popup.setAttribute("inert", ""),
        this.popup.removeAttribute(nd),
        !Il() &&
          this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:onclose", { bubbles: !1 })
        ),
        this.enableScrollLock &&
          (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
    }
    popupEvents() {
      if (!this.popup) return;
      this.buttonPopupOpen?.addEventListener("click", (t) => {
        t.preventDefault(),
          this.popupOpen(),
          (window.accessibility.lastElement = this.buttonPopupOpen);
      });
      const t = this.popup.querySelectorAll(id);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("close", () => this.popupCloseActions());
    }
  }
  const ad = "dialog";
  class ld extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      new rd(this.querySelector(ad), this, !0, !0);
    }
  }
  class cd extends Ut {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent(),
        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
    }
    setupModelViewerUI(t) {
      t ||
        (this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector("model-viewer")
        ));
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const hd = "[data-add-to-cart]",
    dd = "[data-product-json]",
    ud = "[data-product-form]",
    pd = "#cart-bar",
    md = "[data-popup-open]",
    gd = ".product__submit__add",
    vd = "[data-form-wrapper]",
    yd = "[data-product-variants]",
    fd = "[data-slider]",
    bd = "is-visible",
    wd = "is-loading",
    Sd = "data-cart-bar-enabled",
    Ed = "data-add-to-cart-bar",
    Ld = "data-cart-bar-scroll",
    kd = "data-cart-bar-product-notification",
    Ad = "data-section-id",
    Cd = "data-slider-index",
    Td = {};
  class qd {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.id = this.container.getAttribute(Ad)),
        (this.sliders = this.container.querySelectorAll(fd)),
        (this.slider = []),
        (this.formWrapper = this.container.querySelector(vd)),
        (this.cartBarEnabled = this.container.hasAttribute(Sd)),
        (this.cartBar = this.container.querySelector(pd)),
        (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
        (this.scrollToTop = this.scrollToTop.bind(this)),
        (this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this)),
        (this.unlockTimer = 0),
        (this.accessibility = N);
      const e = this.container.querySelector(dd);
      if ((e && !e.innerHTML) || !e) return;
      const s = JSON.parse(e.innerHTML).handle;
      let i = {};
      s && (i = { handle: s }),
        Shopify.Products.recordRecentlyViewed(i),
        (this.form = this.container.querySelector(ud)),
        this.sliders.length &&
          this.sliders.forEach((t, e) => {
            t.setAttribute(Cd, e), this.slider.push(new sn(this.container, t));
          }),
        this.cartBarEnabled &&
          (this.initCartBar(),
          this.setCartBarHeight(),
          document.addEventListener("theme:scroll", this.toggleCartBarOnScroll),
          document.addEventListener("theme:resize", this.setCartBarHeight));
    }
    initCartBar() {
      (this.cartBarBtns = this.cartBar.querySelectorAll(gd)),
        this.cartBarBtns.length > 0 &&
          this.cartBarBtns.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault(),
                t.currentTarget.hasAttribute(Ed)
                  ? (this.cartBarEnabled &&
                      (t.currentTarget.classList.add(wd),
                      t.currentTarget.setAttribute("disabled", "disabled")),
                    this.form
                      .querySelector(hd)
                      .dispatchEvent(new Event("click", { bubbles: !0 })))
                  : t.currentTarget.hasAttribute(Ld)
                  ? this.scrollToTop()
                  : t.currentTarget.hasAttribute(kd) &&
                    this.container
                      .querySelector(md)
                      .dispatchEvent(new Event("click"));
            }),
              t.hasAttribute(Ed) &&
                document.addEventListener(
                  "theme:product:add-error",
                  this.scrollToTop
                );
          }),
        this.setCartBarHeight();
    }
    scrollToTop() {
      const t = this.container.querySelector(yd),
        e = (v() ? this.container : t || this.form).getBoundingClientRect().top;
      nn(v() ? e : e - 10);
    }
    toggleCartBarOnScroll() {
      const t = window.scrollY,
        e =
          theme.variables.productPageSticky && this.formWrapper
            ? this.formWrapper
            : this.form;
      if (e && this.cartBar) {
        const s = t > e.offsetTop + e.offsetHeight;
        this.cartBar.classList.toggle(bd, s);
      }
    }
    setCartBarHeight() {
      const t = this.cartBar.offsetHeight;
      document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
    }
    onUnload() {
      document.removeEventListener("theme:product:add-error", this.scrollToTop),
        this.cartBarEnabled &&
          (document.removeEventListener(
            "theme:scroll",
            this.toggleCartBarOnScroll
          ),
          document.removeEventListener("theme:resize", this.setCartBarHeight));
    }
    onBlockSelect(t) {
      const e = t.srcElement.closest(fd);
      if (e && this.slider.length) {
        const s = e.hasAttribute(Cd) ? e.getAttribute(Cd) : 0;
        if (!this.slider[s]) return;
        this.slider[s].onBlockSelect(t);
      }
    }
    onBlockDeselect(t) {
      const e = t.srcElement.closest(fd);
      if (e && this.slider.length) {
        const s = e.hasAttribute(Cd) ? e.getAttribute(Cd) : 0;
        if (!this.slider[s]) return;
        this.slider[s].onBlockDeselect(t);
      }
    }
  }
  yo("product", [
    {
      onLoad() {
        Td[this.id] = new qd(this);
      },
      onUnload(t) {
        Td[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Td[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Td[this.id].onBlockDeselect(t);
      },
    },
    Po,
    Ml,
    yc,
  ]),
    customElements.get("product-form") ||
      customElements.define("product-form", ed),
    customElements.get("product-images") ||
      customElements.define("product-images", _c),
    customElements.get("product-modal") ||
      customElements.define("product-modal", ld),
    customElements.get("product-model") ||
      customElements.define("product-model", cd),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", nl),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ja),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", lc);
  const xd = "[data-api-related-template]",
    Pd = "[data-related-section]",
    Md = "[data-grid-item]",
    Id = "[data-recent-wrapper]",
    Hd = "[data-recently-viewed-wrapper]",
    Od = ".product-item",
    Dd = "grid-slider",
    Bd = "data-limit",
    _d = "data-minimum",
    Fd = "data-product-id",
    $d = "is-hidden",
    Nd = "grid--mobile-slider",
    Wd = {};
  class Rd {
    constructor(t) {
      (this.section = t),
        (this.sectionId = t.id),
        (this.container = t.container),
        this.related(),
        this.recent();
    }
    related() {
      const t = this.container.querySelector(Pd);
      if (!t) return;
      const e = t.getAttribute(Fd),
        s = t.getAttribute(Bd),
        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
      fetch(i)
        .then((t) => t.text())
        .then((e) => {
          const s = document.createElement("div");
          s.innerHTML = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(xd).innerHTML;
          if (s.querySelector(Md)) {
            t.innerHTML = s.innerHTML;
            if (0 === parseInt(t.style.getPropertyValue("--COLUMNS-MOBILE"))) {
              t.querySelector(Md).parentElement.classList.add(Nd);
            }
          } else
            t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
        })
        .catch(function () {
          t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
        });
    }
    recent() {
      const t = this.container.querySelector(Id),
        e = t ? parseInt(t.getAttribute(Bd)) : 4;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: e,
        wrapperId: `recently-viewed-products-${this.sectionId}`,
        section: this.section,
        target: "api-product-grid-item",
        onComplete: (t, e) => {
          const s = e.container;
          if (!s) return;
          const i = s.querySelector(Id),
            o = s.querySelector(Hd),
            n = t.querySelectorAll(Od),
            r = i.querySelector(Dd),
            a = i.hasAttribute(_d) ? parseInt(i.getAttribute(_d)) : 4,
            l = !o && n.length > 0,
            c = o && n.length >= a;
          (l || c) &&
            (c && o.classList.remove($d),
            i.classList.remove("is-hidden"),
            i.dispatchEvent(
              new CustomEvent("theme:tab:check", { bubbles: !0 })
            ),
            r &&
              r.dispatchEvent(
                new CustomEvent("theme:grid-slider:init", { bubbles: !0 })
              ));
        },
      });
    }
  }
  yo("related", [
    {
      onLoad() {
        Wd[this.id] = new Rd(this);
      },
    },
    Ml,
  ]),
    yo("reviews", [on, Kr]);
  const zd = {},
    Ud = "[data-slider-logos]",
    Vd = "[data-slider-text]",
    jd = "[data-slide]",
    Xd = "is-selected",
    Jd = "is-initialized",
    Yd = "flickity-enabled",
    Qd = "data-slide",
    Gd = "data-slide-index";
  class Kd {
    constructor(t) {
      (this.container = t.container),
        (this.slideshowNav = this.container.querySelector(Ud)),
        (this.slideshowText = this.container.querySelector(Vd)),
        (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
        (this.flkty = null),
        (this.flktyNav = null),
        (this.logoSlides = this.slideshowNav.querySelectorAll(jd)),
        (this.logoSlidesWidth = this.getSlidesWidth()),
        this.initSlideshowText(),
        this.initSlideshowNav();
    }
    getSlidesWidth() {
      return 200 * this.logoSlides.length;
    }
    initSlideshowText() {
      this.slideshowText &&
        (this.flkty = new i(this.slideshowText, {
          fade: !0,
          autoPlay: !1,
          prevNextButtons: !1,
          cellAlign: "left",
          contain: !0,
          pageDots: !1,
          wrapAround: !1,
          selectedAttraction: 0.2,
          friction: 0.6,
          draggable: !1,
          accessibility: !1,
          on: {
            ready: () => this.sliderAccessibility(),
            change: () => this.sliderAccessibility(),
          },
        }));
    }
    sliderAccessibility() {
      const t = this.slideshowText.querySelectorAll(`${jd} a, ${jd} button`);
      t.length &&
        t.forEach((t) => {
          const e = t.closest(jd);
          if (e) {
            const s = e.classList.contains(Xd) ? 0 : -1;
            t.setAttribute("tabindex", s);
          }
        });
    }
    initSlideshowNav() {
      this.slideshowNav &&
        (this.logoSlides.length &&
          this.logoSlides.forEach((t) => {
            t.addEventListener("click", () => {
              const e = parseInt(t.getAttribute(Gd)),
                s = this.slideshowNav.classList.contains(Yd);
              if ((this.flkty && this.flkty.select(e), s))
                this.flktyNav.select(e),
                  this.slideshowNav.classList.contains(Xd) ||
                    this.flktyNav.playPlayer();
              else {
                const e = this.slideshowNav.querySelector(`.${Xd}`);
                e && e.classList.remove(Xd), t.classList.add(Xd);
              }
            });
          }),
        this.setSlideshowNavState(),
        document.addEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        ));
    }
    setSlideshowNavState() {
      const t = this.slideshowNav.classList.contains(Yd);
      if (this.logoSlidesWidth > m()) {
        if (!t) {
          this.slideshowNav.classList.add(Jd);
          const t = this.slideshowNav.querySelector(`.${Xd}`);
          t && t.classList.remove(Xd),
            this.logoSlides[0].classList.add(Xd),
            this.flktyNav ||
              ((this.flktyNav = new s(this.slideshowNav, {
                autoPlay: 4e3,
                prevNextButtons: !1,
                contain: !1,
                pageDots: !1,
                wrapAround: !0,
                watchCSS: !0,
                selectedAttraction: 0.05,
                friction: 0.8,
                initialIndex: 0,
              })),
              this.flktyNav.on("deactivate", () => {
                this.slideshowNav.querySelector(jd).classList.add(Xd),
                  this.flkty && this.flkty.select(0);
              }),
              this.flkty &&
                (this.flkty.select(0),
                this.flktyNav.on("change", (t) => this.flkty.select(t))));
        }
      } else t && this.slideshowNav.classList.remove(Jd);
    }
    onBlockSelect(t) {
      if (!this.slideshowNav) return;
      const e = this.slideshowNav.querySelector(
          `[${Qd}="${t.detail.blockId}"]`
        ),
        s = parseInt(e.getAttribute(Gd));
      this.slideshowNav.classList.contains(Yd)
        ? (this.flktyNav.select(s),
          this.flktyNav.stopPlayer(),
          this.slideshowNav.classList.add(Xd))
        : e.dispatchEvent(new Event("click"));
    }
    onBlockDeselect() {
      this.slideshowNav &&
        this.slideshowNav.classList.contains(Yd) &&
        (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(Xd));
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize",
        this.setSlideshowNavStateOnResize
      );
    }
  }
  yo("logos", [
    {
      onLoad() {
        zd[this.id] = new Kd(this);
      },
      onUnload(t) {
        zd[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        zd[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        zd[this.id].onBlockDeselect(t);
      },
    },
    Kr,
  ]);
  const Zd = {};
  function tu(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return Zd[t.url]
        ? Zd[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (Zd[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return Zd[t.json]
        ? Promise.resolve(Zd[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((Zd[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return Zd[e]
        ? Zd[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (Zd[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const eu = ".pswp",
    su = ".pswp__custom-close",
    iu = "iframe, video",
    ou = ".pswp__thumbs",
    nu = "is-current",
    ru = "pswp--custom-loader",
    au = "pswp--custom-opening",
    lu = "pswp__loader",
    cu = "is-focused",
    hu = "data-pswp-option-classes",
    du = "aria-current",
    uu = `<div class="${lu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  class pu {
    constructor(t, e = "") {
      (this.items = t),
        (this.pswpElement = document.querySelectorAll(eu)[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(ou)),
        (this.closeBtn = this.pswpElement.querySelector(su)),
        (this.keyupCloseEvent = (t) => this.keyupClose(t)),
        (this.a11y = N);
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        this.init();
    }
    init() {
      this.pswpElement.classList.add(au),
        this.initLoader(),
        tu({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(ru) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(hu, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = uu), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(hu, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(ru) &&
        this.pswpElement.classList.remove(ru),
        this.pswpElement.classList.remove(au),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.init(),
        this.thumbsActions(),
        document.body.classList.contains(cu) &&
          setTimeout(() => {
            this.a11y.trapFocus(this.pswpElement, {
              elementToFocus: this.closeBtn,
            });
          }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.children.length &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${ou} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i = t.parentElement.querySelector(`.${nu}`);
            i.classList.remove(nu),
              i.setAttribute(du, !1),
              t.classList.add(nu),
              t.setAttribute(du, !0),
              this.popup.goTo(e);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    keyupClose(t) {
      "Enter" === t.code && this.popup.close();
    }
    onClose() {
      const t = this.pswpElement.querySelector(iu);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(hu, "");
      const e = this.pswpElement.querySelector(`.${lu}`);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement();
    }
    setCurrentThumb() {
      const t = this.pswpElement.querySelector(`${ou} > .${nu}`);
      if (
        (t && (t.classList.remove(nu), t.setAttribute(du, !1)),
        !this.popupThumbs)
      )
        return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(nu), e.setAttribute(du, !0), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = t.offsetLeft;
      if (e <= s + t.offsetWidth || e > s) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - e,
          behavior: "smooth",
        });
      }
    }
  }
  const mu = "data-video-play";
  class gu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.videoPlay = this.querySelectorAll(`[${mu}]`)),
        this.videoPlay?.forEach((t) => {
          t.addEventListener("click", (t) => {
            const e = t.currentTarget;
            if ("" !== e.getAttribute(mu).trim()) {
              t.preventDefault();
              const s = [{ html: e.getAttribute(mu) }];
              new pu(s, { mainClass: "pswp--video" }),
                (window.accessibility.lastElement = e);
            }
          });
        });
    }
  }
  const vu = "[data-video-template]",
    yu = "is-loading",
    fu = "data-video-id";
  class bu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.videoId = this.getAttribute(fu)),
        (this.videoTemplate = this.querySelector(vu)),
        (this.video = null),
        (this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this)),
        this.videoId && this.renderVideo();
    }
    powerSaverVideoPlay() {
      this.video?.play();
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(yu),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                this.video
                  .play()
                  .then(() => {})
                  .catch(() => {
                    document.addEventListener(
                      "click",
                      this.powerSaverVideoPlay,
                      { passive: !0, bubbles: !0, once: !0 }
                    ),
                      document.addEventListener(
                        "touchstart",
                        this.powerSaverVideoPlay,
                        { passive: !0, bubbles: !0, once: !0 }
                      );
                  }),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            if (e && "function" == typeof this.video.play) {
              const t = this.video.play();
              void 0 !== t && t.then((t) => {}).catch((t) => {});
            }
            e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        { rootMargin: "0px", threshold: [0, 1] }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect(),
        this.videoId &&
          (document.removeEventListener("click", this.powerSaverVideoPlay),
          document.removeEventListener("touchstart", this.powerSaverVideoPlay));
    }
  }
  yo("featured-video", [Io]),
    customElements.get("video-background") ||
      customElements.define("video-background", bu),
    customElements.get("video-popup") ||
      customElements.define("video-popup", gu),
    yo("slideshow", [on, Io]);
  const wu = "[data-image-holder]",
    Su = "[data-image-element]",
    Eu = "[data-range-button]",
    Lu = "[data-range-input]";
  class ku extends HTMLElement {
    constructor() {
      super(),
        (this.imageHolder = this.querySelector(wu)),
        (this.imageElement = this.querySelector(Su)),
        (this.rangeButton = this.querySelector(Eu)),
        (this.rangeInput = this.querySelector(Lu)),
        (this.setOverlapImageSize = this.setOverlapImageSize.bind(this));
    }
    connectedCallback() {
      this.setOverlapImageSize(),
        this.setImagePosition(),
        this.rangeInput.addEventListener("input", () =>
          this.setImagePosition()
        ),
        document.addEventListener("theme:resize", this.setOverlapImageSize);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.setOverlapImageSize);
    }
    setImagePosition() {
      const t = this.rangeInput.value,
        e = this.imageElement.offsetWidth,
        s = this.rangeButton.offsetWidth;
      (this.rangeButton.style.left = `${t}%`),
        (this.imageHolder.style.width =
          ((e - s) * (100 - t)) / 100 + s / 2 + "px");
    }
    setOverlapImageSize() {
      const t = this.offsetWidth;
      (this.imageElement.style.width = `${t}px`), this.setImagePosition();
    }
  }
  yo("custom-content", [on, Io, vn]),
    customElements.get("video-background") ||
      customElements.define("video-background", bu),
    customElements.get("video-popup") ||
      customElements.define("video-popup", gu),
    customElements.get("compare-images") ||
      customElements.define("compare-images", ku);
  var Au = {};
  function Cu(t) {
    return Au[t];
  }
  (Au.basic = []),
    (Au.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (Au.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (Au.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let Tu = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  class qu {
    constructor(t) {
      (this.container = t.container),
        (this.mapContainer = this.container.querySelector(
          "[data-map-container]"
        )),
        (this.key = this.container.getAttribute("data-api-key")),
        (this.styleString = this.container.getAttribute("data-style") || ""),
        (this.zoomString = this.container.getAttribute("data-zoom") || 14),
        (this.address = this.container.getAttribute("data-address")),
        (this.enableCorrection = this.container.getAttribute(
          "data-latlong-correction"
        )),
        (this.lat = this.container.getAttribute("data-lat")),
        (this.long = this.container.getAttribute("data-long")),
        this.key && this.initMaps();
    }
    initMaps() {
      (function (t) {
        if (null === window.theme.mapAPI) {
          const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
          window.theme.mapAPI = tu({ url: e });
        }
        return window.theme.mapAPI;
      })(this.key)
        .then(() => {
          return "true" === this.enableCorrection &&
            "" !== this.lat &&
            "" !== this.long
            ? new google.maps.LatLng(this.lat, this.long)
            : ((t = this.address),
              new Promise((e, s) => {
                new google.maps.Geocoder().geocode(
                  { address: t },
                  function (t, i) {
                    if ("OK" == i) {
                      var o = {
                        lat: t[0].geometry.location.lat(),
                        lng: t[0].geometry.location.lng(),
                      };
                      e(o);
                    } else s(i);
                  }
                );
              }));
          var t;
        })
        .then((t) => {
          const e = {
              zoom: parseInt(this.zoomString, 10),
              styles: Cu(this.styleString),
              center: t,
              draggable: !0,
              clickableIcons: !1,
              scrollwheel: !1,
              zoomControl: !1,
              disableDefaultUI: !0,
            },
            s = (function (t, e) {
              var s = new google.maps.Map(t, e),
                i = s.getCenter();
              return (
                new google.maps.Marker({ map: s, position: i }),
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(s, "resize"), s.setCenter(i);
                }),
                s
              );
            })(this.mapContainer, e);
          return s;
        })
        .then((t) => {
          (this.map = t), (Tu[this.id] = t);
        })
        .catch((t) => {
          console.log("Failed to load Google Map"), console.log(t);
        });
    }
    unload() {
      void 0 !== window.google &&
        google.maps.event.clearListeners(this.map, "resize");
    }
  }
  yo("map", {
    onLoad() {
      Tu[this.id] = new qu(this);
    },
    onUnload() {
      "function" == typeof Tu[this.id].unload && Tu[this.id].unload();
    },
  });
  const xu = "[data-large-promo]",
    Pu = "[data-large-promo-inner]",
    Mu = "[data-tracking-consent]",
    Iu = "[data-confirm-cookies]",
    Hu = "cart-bar",
    Ou = "[data-newsletter]",
    Du = "[data-newsletter-holder]",
    Bu = "[data-newsletter-heading]",
    _u = "[data-newsletter-field]",
    Fu = "[data-promo-text]",
    $u = "[data-newsletter-form]",
    Nu = "data-popup-delay",
    Wu = "data-cookie-name",
    Ru = "data-target-referrer",
    zu = "hidden",
    Uu = "has-value",
    Vu = "cart-bar-visible",
    ju = "is-visible",
    Xu = "has-success",
    Ju = "selected",
    Yu = "has-block-selected",
    Qu = "mobile",
    Gu = "desktop",
    Ku = "bottom",
    Zu = "data-enable";
  let tp = {};
  class ep {
    constructor(t, e, s) {
      if (
        ((this.element = e),
        (this.delay = t.getAttribute(Nu)),
        (this.isSubmitted =
          -1 !== window.location.href.indexOf("accepts_marketing") ||
          -1 !== window.location.href.indexOf("customer_posted=true")),
        (this.popupActions = s),
        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
        ("always" === this.delay || this.isSubmitted) && this.always(),
        this.delay && this.delay.includes("delayed") && !this.isSubmitted)
      ) {
        const t = this.delay.includes("_")
          ? parseInt(this.delay.split("_")[1])
          : 10;
        this.delayed(t);
      }
      "bottom" !== this.delay || this.isSubmitted || this.bottom(),
        "idle" !== this.delay || this.isSubmitted || this.idle();
    }
    always() {
      this.popupActions.popupOpen();
    }
    delayed(t = 10) {
      setTimeout(() => {
        this.popupActions.popupOpen();
      }, 1e3 * t);
    }
    idle() {
      let t = 0;
      const e = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        s = ["load", "resize", "scroll"],
        i = () => {
          (t = setTimeout(() => {
            (t = 0), this.popupActions.popupOpen();
          }, 6e4)),
            e.forEach((t) => {
              document.addEventListener(t, o);
            }),
            s.forEach((t) => {
              window.addEventListener(t, o);
            });
        },
        o = () => {
          t && clearTimeout(t),
            e.forEach((t) => {
              document.removeEventListener(t, o);
            }),
            s.forEach((t) => {
              window.removeEventListener(t, o);
            }),
            i();
        };
      i();
    }
    bottom() {
      document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
    showPopupOnScroll() {
      window.scrollY + window.innerHeight >= document.body.clientHeight &&
        (this.popupActions.popupOpen(),
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        ));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
  }
  class sp {
    constructor(t) {
      if (
        ((this.el = t),
        (this.locationPath = location.href),
        !this.el.hasAttribute(Ru))
      )
        return !1;
      this.init();
    }
    init() {
      -1 !== this.locationPath.indexOf(this.el.getAttribute(Ru)) ||
        window.Shopify.designMode ||
        this.el.parentNode.removeChild(this.el);
    }
  }
  class ip {
    constructor(t) {
      (this.popup = t),
        (this.modal = this.popup.querySelector(Pu)),
        (this.form = this.popup.querySelector($u)),
        (this.cookie = new rn(this.popup.getAttribute(Wu), "user_has_closed")),
        (this.isTargeted = new sp(this.popup)),
        (this.popupActions = new rd(this.modal, this.modal, !0, !0)),
        (this.a11y = N),
        this.init();
    }
    init() {
      const t = !1 !== this.cookie.read(),
        e = this.popup.classList.contains(Qu),
        s = this.popup.classList.contains(Gu),
        i = !v();
      let o = !0;
      if ((((e && !i) || (s && i)) && (o = !1), !o))
        return (
          this.a11y.removeTrapFocus(),
          void document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          )
        );
      (t && !window.Shopify.designMode) ||
        (window.Shopify.designMode ||
          window.location.pathname.endsWith("/challenge") ||
          new ep(this.popup, this.modal, this.popupActions),
        this.form && this.form.classList.contains(Xu) && this.checkForSuccess(),
        this.modal.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        ));
    }
    checkForSuccess() {
      this.popupActions.popupOpen(), this.cookie.write();
    }
    onBlockSelect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupOpen(),
        this.popup.classList.add(Ju),
        this.popup.parentNode.classList.add(Yu));
    }
    onBlockDeselect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupClose(),
        this.popup.classList.remove(Ju),
        this.popup.parentNode.classList.remove(Yu));
    }
  }
  class op {
    constructor(t) {
      (this.popup = t),
        (this.modal = document.querySelector(Mu)),
        (this.acceptButton = this.modal.querySelector(Iu)),
        (this.enable = "true" === this.modal.getAttribute(Zu)),
        (this.showPopup = !1),
        (this.popupActions = new rd(this.popup, this.popup, !1, !1)),
        window.Shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          (t) => {
            if (t) throw t;
            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
              s = window.Shopify.customerPrivacy.getTrackingConsent();
            (this.showPopup = !e && "no_interaction" === s && this.enable),
              window.Shopify.designMode && (this.showPopup = !0),
              this.init();
          }
        );
    }
    init() {
      this.showPopup && this.popupActions.popupOpen(), this.clickEvents();
    }
    clickEvents() {
      this.acceptButton.addEventListener("click", (t) => {
        t.preventDefault(),
          window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
            this.popupActions.popupClose()
          ),
          document.documentElement.style.setProperty(
            "--cookie-bar-height",
            "0px"
          );
      }),
        document.addEventListener("trackingConsentAccepted", () => {});
    }
    onSelect() {
      this.showPopup &&
        (this.popupActions.popupOpen(),
        this.popup.classList.add(Ju),
        this.popup.parentNode.classList.add(Yu));
    }
    onDeselect() {
      this.showPopup &&
        (this.popupActions.popupClose(),
        this.popup.classList.remove(Ju),
        this.popup.parentNode.classList.remove(Yu));
    }
  }
  class np {
    constructor(t) {
      (this.popup = t),
        (this.cookie = new rn(this.popup.getAttribute(Wu), "user_has_closed")),
        (this.isTargeted = new sp(this.popup)),
        (this.popupActions = new rd(this.popup, this.popup, !1, !1)),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (window.Shopify.designMode
          ? this.popupActions.popupOpen()
          : new ep(this.popup, this.popup, this.popupActions),
        this.popup.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        ));
    }
    onSelect() {
      this.popupActions.popupOpen(),
        this.popup.classList.add(Ju),
        this.popup.parentNode.classList.add(Yu);
    }
    onDeselect() {
      this.popupActions.popupClose(),
        this.popup.classList.remove(Ju),
        this.popup.parentNode.classList.remove(Yu);
    }
  }
  class rp {
    constructor(t) {
      (this.popup = t),
        (this.holder = this.popup.querySelector(Du)),
        (this.heading = this.popup.querySelector(Bu)),
        (this.newsletterField = this.popup.querySelector(_u)),
        (this.cookie = new rn(
          this.popup.getAttribute(Wu),
          "newsletter_is_closed"
        )),
        (this.form = this.popup.querySelector($u)),
        (this.isTargeted = new sp(this.popup)),
        (this.popupActions = new rd(this.holder, this.holder, !1, !1)),
        (this.resetClassTimer = 0),
        this.init();
    }
    init() {
      const t = !1 !== this.cookie.read(),
        e = -1 !== window.location.search.indexOf("?customer_posted=true"),
        s = [...this.holder.classList].toString().includes(Ku);
      e && (this.delay = 0),
        (t && !window.Shopify.designMode) ||
          (this.show(),
          this.form.classList.contains(Xu) && this.checkForSuccess()),
        s && this.observeCartBar();
    }
    show() {
      window.location.pathname.endsWith("/challenge") ||
        (window.Shopify.designMode
          ? this.popupActions.popupOpen()
          : new ep(this.popup, this.holder, this.popupActions)),
        this.showForm(),
        this.inputField(),
        this.holder.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        );
    }
    checkForSuccess() {
      this.popupActions.popupOpen(), this.cookie.write();
    }
    observeCartBar() {
      if (((this.cartBar = document.getElementById(Hu)), !this.cartBar)) return;
      let t = this.cartBar.classList.contains(ju);
      document.body.classList.toggle(Vu, t);
      (this.observer = new MutationObserver((e) => {
        for (const s of e)
          "attributes" === s.type &&
            ((t = s.target.classList.contains(ju)),
            document.body.classList.toggle(Vu, t));
      })),
        this.observer.observe(this.cartBar, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
    }
    showForm() {
      this.heading.addEventListener("click", (t) => {
        t.preventDefault(),
          this.heading.classList.add(zu),
          this.form.classList.remove(zu),
          this.newsletterField.focus();
      }),
        this.heading.addEventListener("keyup", (t) => {
          "Enter" === t.code && this.heading.dispatchEvent(new Event("click"));
        });
    }
    inputField() {
      const t = () => {
        this.resetClassTimer && clearTimeout(this.resetClassTimer),
          "" !== this.newsletterField.value && this.holder.classList.add(Uu);
      };
      this.newsletterField.addEventListener("input", t),
        this.newsletterField.addEventListener("focus", t),
        this.newsletterField.addEventListener("focusout", () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            (this.resetClassTimer = setTimeout(() => {
              this.holder.classList.remove(Uu);
            }, 2e3));
        });
    }
    onBlockSelect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupOpen(),
        this.popup.classList.add(Ju),
        this.popup.parentNode.classList.add(Yu));
    }
    onBlockDeselect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupClose(),
        this.popup.classList.remove(Ju),
        this.popup.parentNode.classList.remove(Yu));
    }
    onUnload() {
      this.observer && this.observer.disconnect();
    }
  }
  yo("popups", [
    {
      onLoad() {
        tp[this.id] = [];
        this.container.querySelectorAll(xu).forEach((t) => {
          tp[this.id].push(new ip(t));
        });
        this.container.querySelectorAll(Mu).forEach((t) => {
          tp[this.id].push(new op(t));
        });
        this.container.querySelectorAll(Ou).forEach((t) => {
          tp[this.id].push(new rp(t));
        });
        this.container.querySelectorAll(Fu).forEach((t) => {
          tp[this.id].push(new np(t));
        });
      },
      onBlockSelect(t) {
        tp[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        tp[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onSelect() {
        tp[this.id].forEach((t) => {
          "function" == typeof t.onSelect && t.onSelect();
        });
      },
      onDeselect() {
        tp[this.id].forEach((t) => {
          "function" == typeof t.onDeselect && t.onDeselect();
        });
      },
      onUnload() {
        tp[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    vn,
  ]);
  const ap = "[data-password-modal]",
    lp = "#login_form .errors";
  class cp {
    constructor(t) {
      (this.container = t.container),
        (this.popupActions = new rd(
          this.container.querySelector(ap),
          this.container,
          !0,
          !0
        )),
        this.container.querySelector(lp) && this.popupActions.popupOpen();
    }
  }
  yo("password-template", {
    onLoad() {
      new cp(this);
    },
  }),
    yo("list-collections", [on, Kr]),
    yo("columns", [Kr, on]),
    yo("newsletter", vn),
    customElements.get("compare-images") ||
      customElements.define("compare-images", ku);
  const hp = "[data-scroll-to]",
    dp = "[data-tooltip]",
    up = "[data-collapsible-trigger]",
    pp = "open",
    mp = "data-scroll-to",
    gp = "data-tooltip-stop-mouseenter",
    vp = {};
  class yp {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.scrollToButtons = this.container.querySelectorAll(hp)),
        this.scrollToButtons.length && this.init();
    }
    init() {
      this.scrollToButtons.forEach((t) => {
        t.addEventListener("click", () => {
          const e = this.container.querySelector(t.getAttribute(mp));
          e && "A" !== t.tagName && this.scrollToElement(e);
        });
      });
    }
    scrollToElement(t) {
      nn(t.getBoundingClientRect().top + 1);
      const e = t.nextElementSibling.matches("details")
        ? t.nextElementSibling
        : null;
      if (e) {
        const t = e?.querySelector(up);
        e.hasAttribute(pp) || t?.dispatchEvent(new Event("click"));
      }
      const s = document.querySelectorAll(`${dp}:not([${gp}])`);
      s.length &&
        s.forEach((t) => {
          t.setAttribute(gp, ""),
            setTimeout(() => {
              t.removeAttribute(gp);
            }, 1e3);
        });
    }
  }
  const fp = {
      onLoad() {
        vp[this.id] = new yp(this);
      },
    },
    bp = "[data-scroll-spy]",
    wp = "is-selected",
    Sp = "data-scroll-spy",
    Ep = "data-scroll-spy-mobile",
    Lp = "data-scroll-spy-desktop",
    kp = "data-scroll-trigger-point",
    Ap = {};
  class Cp {
    constructor(t, e) {
      (this.container = t),
        (this.elementToSpy = e),
        (this.anchorSelector = `[${Sp}="#${this.elementToSpy.id}"]`),
        (this.anchor = this.container.querySelector(this.anchorSelector)),
        (this.anchorSiblings = this.container.querySelectorAll(`[${Sp}]`)),
        (this.initialized = !1),
        this.anchor &&
          ((this.triggerPoint = this.anchor.getAttribute(kp)),
          (this.scrollCallback = () => this.onScroll()),
          (this.toggleScrollObserver = this.toggleScrollObserver.bind(this)),
          this.init());
    }
    init() {
      this.toggleScrollObserver(),
        document.addEventListener(
          "theme:resize:width",
          this.toggleScrollObserver
        );
    }
    toggleScrollObserver() {
      this.isEligible()
        ? this.initialized ||
          (document.addEventListener("theme:scroll", this.scrollCallback),
          (this.initialized = !0))
        : (document.removeEventListener("theme:scroll", this.scrollCallback),
          (this.initialized = !1));
    }
    isEligible() {
      const t = v();
      return (
        (!t && this.anchor.hasAttribute(Ep)) ||
        (t && this.anchor.hasAttribute(Lp)) ||
        (!this.anchor.hasAttribute(Lp) && !this.anchor.hasAttribute(Ep))
      );
    }
    onScroll() {
      this.top = this.elementToSpy.getBoundingClientRect().top;
      const t = Math.round(window.innerHeight),
        e = Math.round(window.scrollY),
        s = e + t,
        i = Math.round(this.top + e),
        o = this.elementToSpy.offsetHeight;
      i < s &&
        !(i + o < e) &&
        this.triggerPointReached() &&
        (this.anchorSiblings.forEach((t) => {
          t.matches(this.anchorSelector) || t.classList.remove(wp);
        }),
        this.anchor.classList.add(wp));
    }
    triggerPointReached() {
      let t = !1;
      switch (this.triggerPoint) {
        case "top":
        default:
          t = this.top <= 0;
          break;
        case "middle":
          t = this.top <= window.innerHeight / 2;
          break;
        case "bottom":
          t = this.top <= window.innerHeight;
      }
      return t;
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.toggleScrollObserver
      ),
        document.removeEventListener("theme:scroll", this.scrollCallback);
    }
  }
  const Tp = {
    onLoad() {
      (Ap[this.id] = []),
        this.container.querySelectorAll(bp)?.forEach((t) => {
          const e = this.container.querySelector(t.getAttribute(Sp));
          Ap[this.id].push(new Cp(this.container, e));
        });
    },
    onUnload() {
      Ap[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  yo("sidebar", [fp, Tp]);
  const qp = "[data-hover-target]",
    xp = "[data-collection-image]",
    Pp = "data-hover-target",
    Mp = "is-visible",
    Ip = "is-selected";
  let Hp = {};
  class Op {
    constructor(t) {
      (this.container = t.container),
        (this.buttons = this.container.querySelectorAll(qp)),
        this.init();
    }
    init() {
      this.buttons.length &&
        this.buttons.forEach((t) => {
          t.addEventListener("mouseenter", (t) => {
            const e = t.currentTarget.getAttribute(Pp);
            this.updateState(e);
          });
        });
    }
    updateState(t) {
      const e = this.container.querySelector(`[${Pp}="${t}"]`),
        s = this.container.querySelector(`#${t}:not(.${Mp})`),
        i = this.container.querySelector(`${qp}.${Ip}`),
        o = this.container.querySelector(`${xp}.${Mp}`);
      s &&
        v() &&
        (o?.classList.remove(Mp),
        i?.classList.remove(Ip),
        s.classList.add(Mp),
        e.classList.add(Ip));
    }
    onBlockSelect(t) {
      this.updateState(t.target.id);
    }
  }
  yo("collections-hover", [
    {
      onLoad() {
        Hp[this.id] = new Op(this);
      },
      onBlockSelect(t) {
        Hp[this.id].onBlockSelect(t);
      },
    },
    Tp,
  ]);
  const Dp = "[data-featured-image]",
    Bp = "[data-featured-aside]",
    _p = "[data-featured-content]",
    Fp = "[data-featured-wrapper]",
    $p = "data-horizontal-scroll",
    Np = "data-horizontal-scroll-reversed",
    Wp = {};
  class Rp {
    constructor(t) {
      (this.container = t.container),
        (this.horizontalScroll = this.container.hasAttribute($p)),
        (this.horizontalScrollReversed = this.container.hasAttribute(Np)),
        (this.images = this.container.querySelectorAll(Dp)),
        (this.imagesHolder = this.container.querySelector(Bp)),
        (this.contentHolder = this.container.querySelector(_p)),
        (this.wrapper = this.container.querySelector(Fp)),
        (this.requestAnimationSticky = null),
        (this.lastPercent = 0),
        (this.scrollEvent = () => this.scrollEvents()),
        (this.calculateHorizontalPositionEvent = () =>
          this.calculateHorizontalPosition()),
        (this.calculateHeightEvent = () => this.calculateHeight()),
        this.init();
    }
    init() {
      this.horizontalScroll &&
        this.imagesHolder &&
        ((this.requestAnimationSticky = requestAnimationFrame(
          this.calculateHorizontalPositionEvent
        )),
        document.addEventListener("theme:scroll", this.scrollEvent)),
        this.wrapper &&
          this.contentHolder &&
          this.images.length &&
          (this.calculateHeight(),
          document.addEventListener(
            "theme:resize:width",
            this.calculateHeightEvent
          ));
    }
    scrollEvents() {
      this.requestAnimationSticky ||
        (this.requestAnimationSticky = requestAnimationFrame(
          this.calculateHorizontalPositionEvent
        ));
    }
    removeAnimationFrame() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null));
    }
    calculateHorizontalPosition() {
      let t = window.scrollY + this.headerHeight;
      const e = t + window.innerHeight,
        s = this.imagesHolder.offsetTop,
        i = this.imagesHolder.offsetHeight,
        o = s + i + this.headerHeight,
        n = i - (window.innerHeight - this.headerHeight),
        r = this.horizontalScrollReversed ? 1 : -1;
      let a = 0;
      (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
        (a *= this.images.length - 1),
        this.container.style.setProperty("--translateX", a * r + "%"),
        this.lastPercent !== a
          ? (this.requestAnimationSticky = requestAnimationFrame(
              this.calculateHorizontalPositionEvent
            ))
          : this.requestAnimationSticky && this.removeAnimationFrame(),
        (this.lastPercent = a);
    }
    calculateHeight() {
      let { stickyHeaderHeight: t } = a();
      this.container.style.removeProperty("--min-height"),
        this.container.style.setProperty(
          "--min-height",
          `${this.wrapper.offsetHeight + this.contentHolder.offsetHeight}px`
        ),
        (this.headerHeight = t);
    }
    onUnload() {
      this.horizontalScroll &&
        this.imagesHolder &&
        document.removeEventListener(
          "theme:scroll",
          this.calculateHorizontalPositionEvent
        ),
        this.wrapper &&
          this.contentHolder &&
          this.images.length &&
          document.removeEventListener(
            "theme:resize:width",
            this.calculateHeightEvent
          );
    }
  }
  yo("featured-product", [
    {
      onLoad() {
        Wp[this.id] = new Rp(this);
      },
      onUnload(t) {
        Wp[this.id].onUnload(t);
      },
    },
  ]);
  const zp = "[data-timeline-holder]",
    Up = "[data-timeline-rows]",
    Vp = "[data-timeline-row]",
    jp = "[data-timeline-row-editor]",
    Xp = "[data-timeline-button]",
    Jp = "[data-block-scroll]",
    Yp = "is-selected",
    Qp = {};
  class Gp {
    constructor(t) {
      (this.container = t.container),
        (this.rows = this.container.querySelectorAll(Vp)),
        (this.holder = this.container.querySelector(zp)),
        this.rows.length < 2 ||
          !this.holder ||
          ((this.rowsWidth = 0),
          (this.rowsHeight = []),
          (this.holderTop =
            this.holder.getBoundingClientRect().top + window.scrollY),
          (this.holderHeight = this.holder.offsetHeight),
          (this.buttons = this.container.querySelectorAll(Xp)),
          (this.rowsHolder = this.container.querySelector(Up)),
          (this.requestAnimation = null),
          (this.isDesktopView = v()),
          (this.isScrollEnabled = !1),
          (this.scrollEvent = (t) => this.scrollEvents(t)),
          (this.resizeEvent = () => this.resizeEvents()),
          this.init());
    }
    init() {
      this.calculateRowsDimensions(),
        (this.requestAnimation = requestAnimationFrame(() =>
          this.calculatePosition()
        )),
        this.isDesktopView &&
          !this.isScrollEnabled &&
          ((this.isScrollEnabled = !0),
          document.addEventListener("theme:scroll", this.scrollEvent)),
        this.rowsHolder.addEventListener("scroll", this.scrollEvent),
        document.addEventListener("theme:resize:width", this.resizeEvent),
        this.buttons.length &&
          this.buttons.forEach((t, e) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
              const s = t.currentTarget.closest(Vp);
              if (s)
                if (v()) {
                  const t = Math.max(...this.rowsHeight),
                    s = this.holderHeight / this.rows.length,
                    i = this.holder.getBoundingClientRect().top;
                  nn((e > 0 && t < s ? s * e + i : i) + 1);
                } else {
                  const t = 16,
                    e = s.offsetLeft - t;
                  this.rowsHolder.scrollTo({ left: e, behavior: "smooth" });
                }
            });
          });
    }
    resizeEvents() {
      (this.holderTop =
        this.holder.getBoundingClientRect().top + window.scrollY),
        (this.holderHeight = this.holder.offsetHeight),
        this.calculateRowsDimensions(),
        (this.requestAnimation = requestAnimationFrame(() =>
          this.calculatePosition()
        ));
      const t = v();
      t && !this.isScrollEnabled
        ? ((this.isScrollEnabled = !0),
          document.addEventListener("theme:scroll", this.scrollEvent))
        : !t &&
          this.isScrollEnabled &&
          ((this.isScrollEnabled = !1),
          document.removeEventListener("theme:scroll", this.scrollEvent));
    }
    scrollEvents(t) {
      if (!this.requestAnimation) {
        const e = t.currentTarget;
        this.requestAnimation = requestAnimationFrame(() =>
          this.calculatePosition(e)
        );
      }
    }
    removeAnimationFrame() {
      this.requestAnimation &&
        (cancelAnimationFrame(this.requestAnimation),
        (this.requestAnimation = null));
    }
    calculateRowsDimensions() {
      if (this.rows.length) {
        (this.rowsHeight = []), (this.rowsWidth = 0);
        let t = 0;
        this.rows.forEach((e, s) => {
          if (
            (this.rowsHeight.push(e.offsetHeight),
            (this.rowsWidth +=
              e.offsetWidth + parseInt(getComputedStyle(e).marginRight)),
            window.Shopify.designMode)
          ) {
            const i = this.container.querySelectorAll(jp);
            i.length &&
              ((t += e.offsetHeight),
              i[s]?.style.setProperty(
                "--row-height-min",
                `${e.offsetHeight}px`
              ),
              i[s + 1]?.style.setProperty("--row-top-mobile", `${t}px`));
          }
        });
      }
    }
    calculatePosition(t = null) {
      this.removeAnimationFrame();
      const e = v(),
        s = this.holderHeight / this.rows.length;
      let i = this.holderTop;
      const o = window.innerHeight,
        n = window.scrollY + 1.5 * o;
      let r = 0;
      if (!e && t) {
        const e = t.scrollLeft - 16,
          s = t.offsetWidth;
        (r = (e / (this.rowsWidth - s)) * 100),
          this.holder.style.setProperty("--percent-mobile", `${r}%`);
      }
      (e &&
        (n < this.holderTop || n > this.holderTop + this.holderHeight + o)) ||
        this.rows.forEach((t, o) => {
          if (o > 0) {
            const o = (t.offsetLeft / this.rowsWidth) * 100;
            let a = r > o;
            e &&
              ((a = i + s < n),
              i - s < n &&
                t.previousElementSibling?.style.setProperty(
                  "--percent-desktop",
                  ((n - i) / s) * 100 + "%"
                )),
              t.classList.toggle(Yp, a);
          }
          i += s;
        });
    }
    onUnload() {
      this.isScrollEnabled &&
        ((this.isScrollEnabled = !1),
        document.removeEventListener("theme:scroll", this.scrollEvent)),
        this.rowsHolder.removeEventListener("scroll", this.scrollEvent),
        document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    onBlockSelect(t) {
      const e = this.container.querySelector(Jp);
      if (e) {
        const s = t.srcElement,
          i = [...s.parentElement.children].indexOf(s),
          o = this.rows[i];
        o && e.scrollTo({ top: 0, left: o.offsetLeft, behavior: "smooth" });
      }
    }
  }
  yo("timeline", [
    {
      onLoad() {
        Qp[this.id] = new Gp(this);
      },
      onUnload(t) {
        Qp[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Qp[this.id].onBlockSelect(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      fo("*");
      document.querySelectorAll(".search-header").forEach((t) => {
        const e = t.querySelector(".predictive-search--empty");
        e &&
          (t.addEventListener("focusin", () => {
            t.classList.add("is-search-focused"), e.classList.remove("hidden");
          }),
          t.addEventListener("focusout", (s) => {
            t.contains(s.relatedTarget) ||
              (t.classList.remove("is-search-focused"),
              e.classList.add("hidden"));
          }),
          e.addEventListener("mousedown", (s) => {
            s.preventDefault();
          }));
      });
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          tu({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ".",
    decimal = ","
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class CashbackPdp extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);

    //Para o bundle de app
    document.addEventListener("DOMContentLoaded", () => {
      const bundleBlock = document.querySelector(".kaching-bundles__block");

      if (bundleBlock) {
        const radioInputs = bundleBlock.querySelectorAll("input[type='radio']");

        const processRadioSelection = (radio) => {
          if (radio.checked) {
            const label = document.querySelector(`label[for='${radio.id}']`);
            if (label) {
              const barPricing = label.querySelector(
                ".kaching-bundles__bar-pricing"
              );

              if (barPricing) {
                const finalPriceElement = barPricing.querySelector(
                  ".kaching-bundles__bar-price"
                );
                const originalPriceElement = barPricing.querySelector(
                  ".kaching-bundles__bar-full-price"
                );

                if (finalPriceElement) {
                  const finalPriceBundle = parseFloat(
                    finalPriceElement.textContent
                      .replace(/[^\d,.-]/g, "")
                      .replace(".", "")
                      .replace(",", ".")
                  );
                  const originalPriceBundle = originalPriceElement
                    ? parseFloat(
                        originalPriceElement.textContent
                          .replace(/[^\d,.-]/g, "")
                          .replace(".", "")
                          .replace(",", ".")
                      )
                    : finalPriceBundle; // Se não houver preço original, assume finalPriceBundle

                  const variant = {
                    price: finalPriceBundle * 100,
                    compare_at_price: originalPriceBundle * 100,
                  };

                  const originalPrice =
                    variant.compare_at_price > variant.price
                      ? variant.compare_at_price
                      : variant.price;
                  const discountValue =
                    document.querySelector("#discount-value").value;
                  const couponValue =
                    document.querySelector("#coupon-value").value;
                  const newValueAfterCoupon =
                    variant.price - variant.price * (couponValue * 0.01);
                  const percentCouponDiscount = (
                    ((originalPrice - newValueAfterCoupon) * 100) /
                    originalPrice
                  ).toFixed(0);
                  const newValue = newValueAfterCoupon * (discountValue * 0.01);
                  /*const pricePixDiscount = newValue * 9.8;
                  document.querySelector(
                    ".preco-pix"
                  ).innerText = `${formatMoney(
                    pricePixDiscount,
                    "R${{amount}}"
                  )}`;*/

                  document.querySelector(
                    ".value-with-discount"
                  ).innerText = `${formatMoney(
                    newValueAfterCoupon,
                    "R${{amount}}"
                  )}`;
                  document.querySelector(".cashback-order-total").innerText =
                    formatMoney(newValueAfterCoupon, "R${{amount}}");
                  document
                    .querySelectorAll(".cashback-total")
                    .forEach(
                      (span) =>
                        (span.innerText = `${formatMoney(
                          newValue,
                          "R${{amount}}"
                        )}`)
                    );
                  document.querySelector(".cashback-neworder-total").innerText =
                    formatMoney(newValue * 4, "R${{amount}}");
                  document.querySelector(".parcelamento").innerText =
                    formatMoney(newValueAfterCoupon / 6, "R${{amount}}");
                  if (document.querySelector(".cashback-final-value"))
                    document.querySelector(".cashback-final-value").innerText =
                      formatMoney(
                        newValueAfterCoupon - newValue,
                        "R${{amount}}"
                      );
                }
              }
            }
          }
        };

        // Adiciona o listener a cada input radio
        radioInputs.forEach((radio) => {
          radio.addEventListener("change", () => processRadioSelection(radio));
        });

        // Verifica qual input já está selecionado ao carregar a página
        radioInputs.forEach((radio) => {
          if (radio.checked) {
            processRadioSelection(radio);
          }
        });
      }
    });
  }

  connectedCallback() {
    document.addEventListener(
      "theme:variant:change",
      this._onVariantChangedListener
    );
  }
  disconnectedCallback() {
    document.removeEventListener(
      "theme:variant:change",
      this._onVariantChangedListener
    );
  }

  _onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) return;
    const originalPrice =
      variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : variant.price;
    const discountValue = this.querySelector("#discount-value").value;
    const couponValue = this.querySelector("#coupon-value").value;
    const newValueAfterCoupon =
      variant["price"] - variant["price"] * (couponValue * 0.01);
    const percentCouponDiscount =
      ((originalPrice - newValueAfterCoupon) * 100) / originalPrice;
    const newValue = newValueAfterCoupon * (discountValue * 0.01);
    this.querySelector(".value-with-discount").innerText = `${formatMoney(
      newValueAfterCoupon,
      "R${{amount}}"
    )}`;
    /*const pricePixDiscount = newValue * 9.8;
    document.querySelector(".preco-pix").innerText = `${formatMoney(
      pricePixDiscount,
      "R${{amount}}"
    )}`;*/
    this.querySelector(".cashback-order-total").innerText = formatMoney(
      newValueAfterCoupon,
      "R${{amount}}"
    );
    this.querySelectorAll(".cashback-total").forEach(
      (span) => (span.innerText = `${formatMoney(newValue, "R${{amount}}")}`)
    );
    this.querySelector(".cashback-neworder-total").innerText = formatMoney(
      newValue * 4,
      "R${{amount}}"
    );
    this.querySelector(".parcelamento").innerText = formatMoney(
      newValueAfterCoupon / 6,
      "R${{amount}}"
    );
    if (this.querySelector(".cashback-final-value"))
      this.querySelector(".cashback-final-value").innerText = formatMoney(
        newValueAfterCoupon - newValue,
        "R${{amount}}"
      );
  }
}

if (!window.customElements.get("cashback-pdp")) {
  window.customElements.define("cashback-pdp", CashbackPdp);
}
